import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch, faDatabase, faLayerGroup, faTag,
  faServer,  faEllipsisV
} from '@fortawesome/free-solid-svg-icons'; // faAsterisk, faChartPie, faList, faChartArea, faFileAlt, faProjectDiagram, faLongArrowAltUp,
// import Tab from "react-bootstrap/Tab";
import $ from 'jquery';
import RcTooltip from 'rc-tooltip';
// import Nav from "react-bootstrap/Nav";
// import RelationshipChartView from "./relationshipChartView";
// import RelationshipListView from "./relationshipListView";
// import MetricsCards from "./metricsCards";
// import BasicPortlet from '../components/basicPortlet';
// import NoErrorComponent from '../monitor/components/monitorNoResult';
// import ChartFilterHeader from '../monitor/components/chartFilterHeader';
// import { LazyLoadComponent } from 'react-lazy-load-image-component';
// import Load from '../components/loadAction';
import { convertDataForListView, getConvertedSize, getChartFilterData, getChartTypeForMonitorCharts, normalizeChartData, filterBoxPlotData } from "../utils/common_utils";
import { getAttributeData } from "../utils/event_handling";
import {
  DQ_CHART_POINTS,
  MIN_MAX_SCALE, REQUIRES_CONTRIBUTION_INSTEAD_OF_CHART, BUTTON_WAIT_TIME, DUPLICATE_METRIC
} from "../utils/constant";
import Image from '../components/image';
// import Summary from "./summary";
import moment from "moment";
// import ChartBody from '../components/chartBody';
import _ from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars';
// import QualdoDataTable from '../components/bootstrapTable';
// import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Popover from 'react-bootstrap/Popover';
import {getIconforMetrics} from '../utils/common_utils';
// import Sampledata from './staticdata/leftpanel_vertical.json'
// import synapse_Sampledata from './staticdata/synapse_leftpanel_vertical.json'
// import saveWatchListData from './staticdata/savewatchlist.json'
let activeItem = {
  'Attribute': 'breadcrumb-item',
  'Dataset': 'breadcrumb-item',
  'Datasource': 'breadcrumb-item',
  'Environment': 'breadcrumb-item',

};

function wrapNameWithTooltip(name, maxLength = 22, triggerContent = null) {
  if (!name || typeof name !== "string") {
    return "";
  }

  const isLong = name.length > maxLength;
  if (!isLong && triggerContent === null) {
    return name;
  }

  return (
    <RcTooltip
      placement="top"
      overlayClassName="rc-tooltip-sm"
      overlay={
        <span style={{ wordBreak: 'break-word' }}>
          {name}
        </span>
      }
      trigger={["hover"]}
      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
    >
      <span>
        {triggerContent === null ? name : triggerContent}
      </span>
    </RcTooltip>
  );
}

document.onkeydown = checkKey;
function checkKey(e) {
  e = e || window.event;
  let downClick = document.getElementById("down")
  if (downClick === null) {
    return
  }
  if (e.keyCode === 38) {
    // up arrow
    //document.getElementById("up").click();
    start("up");
  }
  else if (e.keyCode === 40) {
    // down arrow

    start("down");
    //document.getElementById("down").click();
  }

}

let funCallFlag;
function start(param) {
  if (funCallFlag !== "undefined") {
    clearInterval(funCallFlag);
  }
  if (param === "up") {

    funCallFlag = setInterval(upButtonClick, BUTTON_WAIT_TIME);
  } else {
    funCallFlag = setInterval(downButtonClick, BUTTON_WAIT_TIME);
  }

}

function upButtonClick(e) {
  document.getElementById("up").click();
  clearInterval(funCallFlag);
}

function downButtonClick(e) {
  document.getElementById("down").click();
  clearInterval(funCallFlag);
}


class Leftpanel extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.changeTab = this.changeTab.bind(this);
    this.changeSource = this.changeSource.bind(this);
    this.getChartFilterData = getChartFilterData.bind(this);
    this.changeData = this.changeData.bind(this);
    this.breadCrumbEvent = this.breadCrumbEvent.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
    this.handleTreeViewButton = this.handleTreeViewButton.bind(this);
    this.processDatasourceChart = this.processDatasourceChart.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeIcon = this.closeIcon.bind(this);
    this.getAttributeData = getAttributeData.bind(this);
    this.getEnvTableData = this.getEnvTableData.bind(this);
    this.reset = this.reset.bind(this);
    let initialSelection = this.props.initialSelection
    let nestedData = this.props.nestedData
    let startDate = moment().subtract(30, 'days');
    let endDate = moment().endOf('day');
    this.state = {
      activeTabKey: "chartView",
      businessRule: null,
      sectionName: "",
      dataType: null,
      outlier: null,
      envTableData: null,
      recencyData: 0,
      disableDown: false,
      disableUp: true,
      distributionData: null,
      profileData: null,
      datasetIds: [],
      startDate: startDate,
      endDate: endDate,
      newData: {},
      isTreeSearch: false,
      datasetRow: 0,
      duplicateRows: 0,
      isRedirect: this.props.isRedirect,
      isFetched: false,
      filteredData: null,
      datasourceCount: 0,
      data: nestedData,
      filterSearch: "",
      leftSearchText: "",
      subString: this.props.subString,
      searchTextFound: true,
      lastRefresh: null,
      attributeCount: 0,
      datasetCount: 0,
      isSearchHappened: this.props.isSearchHappened,
      selectedDataSource: null,
      isChartChanged: false,
      driftOnMetricsChart: null,
      selectedData: [],
      isDataChanged: false,
      currentIndex: 0,
      highlightedType: "",
      highlightedId: null,
      showTreeView: false,
      metricsOptions: [],
      envName: initialSelection.envName,
      datasourceName: initialSelection.datasourceName,
      datasetName: initialSelection.datasetName,
      attributeName: initialSelection.attributeName,
      filteredValues: [],
      driftOnMetricsKey: null,
      showCustomCheckbox: this.props.showCustomCheckbox,
      isNodeHasActions: this.props.isNodeHasActions,
      showSearchFilter: this.props.showSearchFilter
    }
  }
  changeTab(tab) {
    this.setState({ activeTabKey: tab });
  }
  handleLoad(value) {
    this.setState({ loadValue: value });
  }
  findAverage(inputArr) {
    if (inputArr !== null && inputArr !== undefined) {
      return inputArr.reduce((a, b) => a + b) / inputArr.length;
    } else {
      return 0;
    }
  }

  getEnvTableData(envData, chartData) {
    let headers = ["Datasource Name", "Dataset Name", "Attribute Count", "Dataset Size", "Last Refreshed Time"];
    let finalOp = [];
    let datasourceData = Object.values(envData)
    for (let i = 0; i < datasourceData.length; i++) {
      let datasourceName = datasourceData[i]["title"]
      let datasetData = Object.values(datasourceData[i]["childNodes"])
      for (let j = 0; j < datasetData.length; j++) {
        let row = [];
        let d = datasetData[j];
        let datasetName = d["title"]
        let datasetId = d["id"]
        let lastRefreshData = chartData.issued_attributes[datasetId]
        let sizeData = this.props.dataModule !== undefined && this.props.dataModule.dataSize.filter(x => x.data_set_id === Number(datasetId))
        let dataSize = 0
        if (sizeData.length > 0) {
          dataSize = getConvertedSize(sizeData[0]["size"])
        }
        let lastRefresh = null
        if (lastRefreshData) {
          lastRefresh = Object.values(lastRefreshData)[0]["refresh_time"]
        }

        let attributeCount = Object.values(d["childNodes"]).length

        row.push({ "value": datasourceName, "type": "td" });
        row.push({ "value": datasetName, "type": "td" });
        row.push({ "value": attributeCount, "type": "td" });
        row.push({ "value": dataSize, "type": "td" });
        row.push({ "value": lastRefresh, "type": "td" });
        finalOp.push(row);
      }
    }
    let tableData = { "headers": headers, "data": finalOp };

    return tableData;

  }
  changeSource(metricName, stateKey, title) {
    let finalData = null
    let filteredData = null
    if (this.state.selectedData !== null && ["Dataset", "Attribute"].includes(this.state.sectionName)) {
      for (let row of this.state.selectedData) {
        if (row["name"] === metricName) {
          finalData = row;
          finalData['data_source_name'] = this.state.datasourceName;
          finalData["datasetName"] = this.state.datasetName;
          finalData['attribute_name'] = this.state.attributeName;
          finalData['error_percentage'] = this.findAverage().toFixed(2);
          if (finalData["name"] === "Data Drift") {
            finalData["boxPlotData"] = filterBoxPlotData(finalData["boxPlotData"])
          }
          filteredData = getChartFilterData(finalData, this.state.startDate, this.state.endDate)
          break;
        }
      }
    } else if (this.state.sectionName === "Datasource") {
      let dataFromProps = this.props.datasourceData[metricName]
      let data = _.cloneDeep(dataFromProps);
      let result = this.processDatasourceChart(data, this.state.selectedDataSource)
      finalData = result["finalData"]
      filteredData = result["filteredData"]

    }


    const metricKey = "attribute_" + metricName;
    this.setState({ driftOnMetricsChart: finalData, filteredData: filteredData, loadValue: false, driftOnMetricsKey: metricKey });
  }
  componentDidUpdate(prevProps) {
    // When metaDataResponse loads/changes while a search is active, force the tree to
    // remount so isOpen states are correctly picked up from the freshly built node data.
    if (
      prevProps.metaDataResponse !== this.props.metaDataResponse &&
      this.state.leftSearchText &&
      this.state.leftSearchText.trim() &&
      !this.props.watchListOpen
    ) {
      this.setState(prevState => ({ isDataChanged: !prevState.isDataChanged }));
    }
    // console.log("verticalLeftpanel.js - componentDidUpdate - prevView:", prevProps.viewIncidentData, "currView:", this.props.viewIncidentData, "targetContext:", this.incidentTargetContext, "triggered:", this.state.incidentChartTriggered);
    if (prevProps.viewIncidentData !== this.props.viewIncidentData) {
       this.setState({ incidentChartTriggered: false });
    } else if (
      this.props.viewIncidentData &&
      !this.state.incidentChartTriggered &&
      this.props.LeftPanelTreeData &&
      Object.keys(this.props.LeftPanelTreeData).length > 0
    ) {
        const vd       = this.props.viewIncidentData;
        const businessId  = vd.business_id;
        const subjectId   = vd.subject_id;
        const kpiId       = vd.kpi_id;
        const datasetId   = vd.dataset_id;
        const attributeId = vd.attribute_id;
        const targetType  = vd.target_type;

        // console.log("[Leftpanel] redirect tree-open triggered. vd:", vd);
        this.setState({
          incidentChartTriggered: true,
          highlightedId: targetType === "KPI"       ? String(kpiId)
                       : targetType === "Dataset"   ? String(datasetId)
                       : targetType === "Attribute" ? String(attributeId)
                       : null,
          highlightedType: targetType
        });

        // openThen(parentToggleId, childId, callback, maxMs, scopeId)
        // ─ If child is already in DOM (optionally scoped to scopeId subtree)
        //     → skip parent click, call callback immediately
        // ─ Otherwise → click parent toggle, poll until child appears, then callback
        //
        // scopeId: if provided, searches within that <li> subtree instead of whole document.
        //          Use this when the same child id appears under multiple parents (e.g. same
        //          dataset under multiple KPIs).
        const openThen = (parentToggleId, childId, callback, maxMs = 10000, scopeId = null) => {
          const findChild = () => {
            if (scopeId) {
              const scope = document.getElementById(scopeId);
              return scope ? scope.querySelector(`[id="${childId}"]`) : null;
            }
            return document.getElementById(childId);
          };

          // Child already visible — no need to click parent
          if (findChild()) {
            // console.log("[redirect] already visible, skip click:", childId);
            setTimeout(callback, 50);
            return;
          }

          // Click parent toggle to reveal child
          const parentEl = document.getElementById(parentToggleId);
          if (parentEl) {
            // console.log("[redirect] opening:", parentToggleId, "→ waiting for:", childId, scopeId ? `(within ${scopeId})` : "");
            parentEl.click();
          } else {
            console.warn("[redirect] parent toggle not found:", parentToggleId);
          }

          const start = Date.now();
          const poll = () => {
            const child = findChild();
            // console.log("[redirect] polling", childId, "→ found:", !!child);
            if (child) {
              setTimeout(callback, 80);
            } else if (Date.now() - start < maxMs) {
              setTimeout(poll, 150);
            } else {
              // console.warn("[redirect] timeout waiting for:", childId, "after", maxMs, "ms");
            }
          };
          setTimeout(poll, 200);
        };

        const baId         = `BusinessArea-left-panel-div-BusinessArea-${businessId}BusinessArea`;
        const saId         = `SubjectArea-left-panel-div-SubjectArea-${subjectId}SubjectArea`;
        const kpiTogId     = `KPI-left-panel-div-KPI-${kpiId}KPI`;
        const kpiLiId      = `KPI-${kpiId}`;
        const datasetTogId = `Dataset-left-panel-div-Dataset-${datasetId}Dataset`;
        const attrTogId    = attributeId ? `Attribute-left-panel-div-Attribute-${attributeId}Attribute` : null;

        const applyHighlight = (scopeParentId) => {
          document.querySelectorAll(".qd-rt_tree-view li").forEach(el => el.classList.remove("active"));
          let liEl = null;
          if (targetType === "Attribute" && attributeId) {
            liEl = document.getElementById(`Attribute-${attributeId}`);
            if (!liEl && scopeParentId) {
              const scope = document.getElementById(scopeParentId);
              liEl = scope ? scope.querySelector(`li[id^="Attribute-${attributeId}"]`) : null;
            }
          } else if (scopeParentId) {
            const scope = document.getElementById(scopeParentId);
            liEl = scope ? scope.querySelector(`li[id="Dataset-${datasetId}"]`) : null;
          } else {
            liEl = document.getElementById(`KPI-${kpiId}`);
          }
          if (liEl) {
            liEl.classList.add("active");
            // console.log("[redirect] ✅ highlighted:", liEl.id);
          } else {
            const fallback = targetType === "Attribute" && attrTogId
              ? document.getElementById(attrTogId)
              : scopeParentId
                ? document.getElementById(`Dataset-${datasetId}`)
                : document.getElementById(`KPI-${kpiId}`);
            if (fallback) { fallback.classList.add("active"); console.log("[redirect] ✅ highlighted (fallback):", fallback.id); }
          }

          let scrollType = targetType;
          let scrollId = null;

          if (scrollType === "Datasource") scrollId = vd.integration_id;
          else if (scrollType === "Dataset") scrollId = datasetId;
          else if (scrollType === "Attribute") scrollId = attributeId;
          else if (scrollType === "BusinessArea") scrollId = businessId;
          else if (scrollType === "SubjectArea") scrollId = subjectId;
          else if (scrollType === "KPI") scrollId = kpiId;

          if (scrollType && scrollId) {
              const elementId = `${scrollType}-left-panel-div-${scrollType}-${scrollId}${scrollType}`;
              const element = document.getElementById(elementId);
              if (element) {
                  const getScrollParent = (node) => {
                      if (node == null || node === document.body) return null;
                      if (node.scrollHeight > node.clientHeight) {
                          const overflowY = window.getComputedStyle(node).overflowY;
                          if (overflowY === 'auto' || overflowY === 'scroll') return node;
                      }
                      return getScrollParent(node.parentNode);
                  };
                  const scrollParent = getScrollParent(element);
                  if (scrollParent) {
                      const parentRect = scrollParent.getBoundingClientRect();
                      const elementRect = element.getBoundingClientRect();
                      const offset = elementRect.top - parentRect.top - (parentRect.height / 2) + (elementRect.height / 2);
                      scrollParent.scrollBy({ top: offset, behavior: 'smooth' });
                  } else {
                      element.scrollIntoView({ behavior: "smooth", block: "center" });
                  }
              }
          }
        };

        if (targetType === "Attribute" && attrTogId) {
          // Level 1: ensure BA is open (SA visible in whole doc)
          openThen(baId, saId, () => {
            // Level 2: ensure SA is open (KPI toggle visible in whole doc)
            openThen(saId, kpiTogId, () => {
              // Level 3: ensure KPI is open — wait for dataset toggle within KPI scope
              openThen(kpiTogId, datasetTogId, () => {
                // Level 4: Click dataset SCOPED to the correct KPI <li>, then poll for attribute.
                // Do NOT use openThen here — its parent click is unscoped and would click the
                // wrong dataset if the same dataset appears under multiple KPIs.
                const kpiScope = document.getElementById(kpiLiId);
                const datasetEl = kpiScope
                  ? kpiScope.querySelector(`[id="${datasetTogId}"]`)
                  : document.getElementById(datasetTogId);
                if (datasetEl) {
                  // console.log("[redirect] clicking dataset (scoped) for attribute:", datasetTogId);
                  datasetEl.click();
                }
                // Level 5: Poll for attribute within KPI scope, then click it scoped.
                const attrStart = Date.now();
                const pollAttr = () => {
                  const scope = document.getElementById(kpiLiId);
                  const attrEl = scope
                    ? scope.querySelector(`[id="${attrTogId}"]`)
                    : document.getElementById(attrTogId);
                  if (attrEl) {
                    // console.log("[redirect] clicking attribute (scoped):", attrTogId);
                    attrEl.click();
                    setTimeout(() => applyHighlight(kpiLiId), 80);
                  } else if (Date.now() - attrStart < 10000) {
                    setTimeout(pollAttr, 150);
                  } else {
                    console.warn("[redirect] timeout waiting for attribute:", attrTogId);
                    applyHighlight(kpiLiId);
                  }
                };
                setTimeout(pollAttr, 200);
              }, 10000, kpiLiId);
            });
          });
        } else if (targetType === "Dataset") {
          // Level 1: ensure BA is open (SA visible in whole doc)
          openThen(baId, saId, () => {
            // Level 2: ensure SA is open (KPI toggle visible in whole doc)
            openThen(saId, kpiTogId, () => {
              // Level 3: ensure KPI is open — wait for dataset toggle to appear within KPI subtree
              openThen(kpiTogId, datasetTogId, () => {
                // Level 4: ALWAYS click the dataset toggle to load the chart.
                // Scoped to the correct KPI <li> to avoid clicking same-id dataset under another KPI.
                const kpiScope  = document.getElementById(kpiLiId);
                const datasetEl = kpiScope
                  ? kpiScope.querySelector(`[id="${datasetTogId}"]`)
                  : document.getElementById(datasetTogId);
                if (datasetEl) {
                  // console.log("[redirect] clicking dataset:", datasetTogId);
                  datasetEl.click();
                  setTimeout(() => applyHighlight(kpiLiId), 80);
                } else {
                  console.warn("[redirect] dataset element not found in KPI scope:", datasetTogId);
                  applyHighlight(kpiLiId);
                }
              }, 10000, kpiLiId);
            });
          });
        } else {
          // Level 1: ensure BA is open (SA visible in whole doc)
          openThen(baId, saId, () => {
            // Level 2: ensure SA is open (KPI toggle visible in whole doc)
            openThen(saId, kpiTogId, () => {
              // Level 3: ALWAYS click the KPI toggle to load the chart
              const kpiEl = document.getElementById(kpiTogId);
              if (kpiEl) {
                // console.log("[redirect] clicking KPI:", kpiTogId);
                kpiEl.click();
              }
              setTimeout(() => applyHighlight(null), 80);
            });
          });
        }
    } else {
        // console.log("[Leftpanel componentDidUpdate] waiting — incidentChartTriggered:", this.state.incidentChartTriggered, "LeftPanelTreeData keys:", this.props.LeftPanelTreeData ? Object.keys(this.props.LeftPanelTreeData).length : 0, "viewIncidentData:", !!this.props.viewIncidentData);
    }

    if (prevProps.nestedData !== this.props.nestedData) {
      let initialSelection = this.props.initialSelection
      let envId = initialSelection.envId
      let datasourceId = initialSelection.datasourceId
      let datasetId = initialSelection.datasetId
      let duplicateRows = 0;
      let attributeId = initialSelection.attributeId
      let filteredValues = [];
      let selectedData = []
      let metricData = []
      let metricsOptions = []
      let chartData = this.props.metricData;
      let sectionName = ""
      let driftOnMetricsChart = null
      let filteredData = null
      let driftOnMetricsKey = null
      let highlightedType = ""
      let highlightedId = null
      let prefix;
      let datasetIds = []
      let attributeCount = 0
      let datasetCount = 0
      let datasourceCount = 0
      let nestedData = this.props.nestedData
      let lastRefresh;
      let datasetRow = 0;
      let envTableData = null
      let recencyData = 0


      if (Object.keys(initialSelection).length !== 0) {
        envId = initialSelection.envId
        datasourceId = initialSelection.datasourceId
        highlightedType = initialSelection.type
        datasetId = initialSelection.datasetId
        attributeId = initialSelection.attributeId
        if (attributeId !== null && attributeId !== undefined) {
          prefix = `${envId}.${datasourceId}.${datasetId}.${attributeId}`
          metricData = Object.values(chartData.attribute_level_data[datasetId][attributeId])
          sectionName = "Attribute"
          this.setState({ isFetched: false });
          this.getAttributeData(datasetId, initialSelection.attributeName);
          highlightedId = attributeId
        } else if (datasetId !== null && datasetId !== undefined) {
          prefix = `${envId}.${datasourceId}.${datasetId}`;
          metricData = Object.values(chartData.dataset_level_data[datasetId])
          sectionName = "Dataset"
          lastRefresh = Object.values(chartData.issued_attributes[datasetId])[0]["refresh_time"]
          datasetIds = [datasetId]
          highlightedId = datasetId
          attributeCount = Object.values(nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"]).length
          let duplicateInfo = this.props.dataModule !== undefined && this.props.dataModule.info[datasourceId][prefix]
          if (duplicateInfo !== undefined) {
            let duplicateRowsList = duplicateInfo[`${DUPLICATE_METRIC}_duplicate_row`]
            if (duplicateRowsList) {
              duplicateRows = duplicateRowsList[duplicateRowsList.length - 1]
            }

          }
        } else if (datasourceId !== null && datasourceId !== undefined) {
          prefix = `${envId}.${datasourceId}`;
          sectionName = "Datasource"
          highlightedId = datasourceId
          datasetIds = Object.keys(nestedData[envId]["childNodes"][datasourceId]["childNodes"])
          datasetCount = datasetIds.length
          for (const key of Object.keys(this.props.datasourceData)) {
            if (key.includes("Data")) {
              metricsOptions.push({ "label": key, "value": key })
            }

          }
          if (metricsOptions.length > 0) {
            let dataFromProps = this.props.datasourceData[metricsOptions[0].value]
            let data = _.cloneDeep(dataFromProps);
            let result = this.processDatasourceChart(data, datasourceId);
            driftOnMetricsChart = result["finalData"]
            filteredData = result["filteredData"]
          }

          let recencyInfo =this.props.dataModule !== undefined && this.props.dataModule.recencyDetails[datasourceId]
          for (let value of Object.values(recencyInfo)) {
            let recencyFiltered = value
            let recencyList = recencyFiltered[`${DUPLICATE_METRIC}_time_value`]
            let latestRecency = 0
            if (recencyList) {
              latestRecency = recencyList[recencyList.length - 1]
            }
            if (latestRecency > 30) {
              recencyData = recencyData + 1
            }
          }
          let duplicateInfo =this.props.dataModule !== undefined && this.props.dataModule.info[datasourceId]
          for (let value of Object.values(duplicateInfo)) {
            let duplicateFiltered = value
            let duplicateRowsList = duplicateFiltered[`${DUPLICATE_METRIC}_duplicate_row`]
            if (duplicateRowsList) {
              duplicateRows = duplicateRowsList[duplicateRowsList.length - 1] + duplicateRows
            }
          }

        } else {
          prefix = `${envId}`;
          sectionName = "Environment"
          datasetCount = 0
          highlightedId = envId
          let total = nestedData[envId]["childNodes"]
          datasourceCount = Object.keys(total).length
          for (const value of Object.values(total)) {
            datasetIds = datasetIds.concat(Object.keys(value["childNodes"]))
            datasetCount = datasetCount + datasetIds.length

          }
          envTableData = this.getEnvTableData(nestedData[envId]["childNodes"], chartData)
        }
        metricData = convertDataForListView(metricData, initialSelection.datasetName, initialSelection.datasourceName)
        for (let i = 0; i < metricData.length; i++) {
          if (metricData[i]["name"] === "Row Count") {
            datasetRow = metricData[i]["value"][metricData[i]["value"].length - 1]
          }
          //           if(metricData[i]["hasDrift"] === false) {
          //             continue
          //           }
          selectedData.push(metricData[i]);
          metricsOptions.push({ "label": metricData[i]["name"], "value": metricData[i]["name"] })
        }
        if (selectedData.length > 0) {
          driftOnMetricsChart = selectedData[0]
          filteredData = getChartFilterData(driftOnMetricsChart, this.state.startDate, this.state.endDate)
          driftOnMetricsKey = sectionName + driftOnMetricsChart["name"]
        }
        filteredValues.push(prefix)

      }
      this.setState({
        data: this.props.nestedData,
        envName: initialSelection.envName,
        datasourceName: initialSelection.datasourceName,
        selectedDataSource: datasourceId,
        lastRefresh: lastRefresh,
        datasetRow: datasetRow,
        duplicateRows: duplicateRows,
        recencyData: recencyData,
        subString: this.props.subString,
        selectedData: selectedData,
        driftOnMetricsChart: driftOnMetricsChart,
        filteredData: filteredData,
        sectionName: sectionName,
        driftOnMetricsKey: driftOnMetricsKey,
        metricsOptions: metricsOptions,
        attributeCount: attributeCount,
        datasourceCount: datasourceCount,
        isTreeSearch: false,
        envTableData: envTableData,
        newData: {},
        filterSearch: "",
        datasetCount: datasetCount,
        datasetIds: datasetIds,
        highlightedId: highlightedId,
        highlightedType: highlightedType,
        isSearchHappened: this.props.isSearchHappened,
        datasetName: initialSelection.datasetName,
        isRedirect: this.props.isRedirect,
        attributeName: initialSelection.attributeName,
        filteredValues: filteredValues,
        envId: envId,
        datasetId: datasetId,
        attributeId: attributeId,
        isDataChanged: !this.state.isDataChanged,
        
      })
    }
  }
  getDefaultSelectedMetrics() {
    let selectedMetricOptions = [];
    if (this.state.metricsOptions.length > 0) {
      selectedMetricOptions = this.state.metricsOptions[0];
      return selectedMetricOptions;
    } else {
      return selectedMetricOptions;
    }
  }

  breadCrumbEvent(e) {
    let type = e.target.id
    if (this.state.highlightedType === type) {
      return
    }
    let envName = this.state.envName
    let datasourceName = this.state.datasourceName
    let datasetName = this.state.datasetName
    let attributeName = this.state.attributeName
    let envId = this.state.envId
    let datasourceId = this.state.selectedDataSource
    let datasetId = this.state.datasetId
    let attributeId = this.state.attributeId
    if (type === "Environment") {
      this.changeData(envName, "", "", "", envId, null,
        null, null, envId, type);
    } else if (type === "Datasource") {
      this.changeData(envName, datasourceName, "", "", envId, datasourceId,
        null, null, datasourceId, type);
    } else if (type === "Dataset") {
      this.changeData(envName, datasourceName, datasetName, "", envId, datasourceId,
        datasetId, null, datasetId, type);
    } else if (type === "Attribute") {
      this.changeData(envName, datasourceName, datasetName, attributeName, envId, datasourceId,
        datasetId, attributeId, attributeId, type);
    }




  }

  changeData(envName, kpiName,datasourceName, datasetName, attributeName, envId, datasourceId,
    datasetId, attributeId, id, type,isOpen, currentIndex = null,title,business_area_id,subject_area_id,kpiId,isChild) {
      if (isOpen) {
        return;
      }
      this.props.renderchartView(envName,kpiName, datasourceName, datasetName, attributeName, envId, datasourceId,
        datasetId, attributeId, id, type,currentIndex = null,title,business_area_id,subject_area_id,kpiId,isChild)
    // let filteredValues = [];
    // let filteredData;
    // let chartData = this.props.metricData;
    // let driftOnMetricsChart = null
    // let driftOnMetricsKey = null
    // let selectedData = []
    // let metricData = []
    // let metricsOptions = []
    // let prefix;
    // let attributeCount;
    // let datasetCount;
    // let datasetIds = [];
    // let envTableData = null
    // let lastRefresh;
    // let duplicateRows = 0;
    // let recencyData = 0
    // let datasourceCount;
    // let sectionName = ""
    // let originalData = _.cloneDeep(this.props.originalData);
    // if (attributeId !== null && attributeId !== undefined) {
    //   prefix = `${envId}.${datasourceId}.${datasetId}.${attributeId}`
    //   metricData = Object.values(chartData.attribute_level_data[datasetId][attributeId])
    //   sectionName = "Attribute"
    //   this.setState({ isFetched: false, distributionData: null });
    //   this.getAttributeData(datasetId, attributeName);
    //   originalData[envId]["isOpen"] = true
    //   originalData[envId]["childNodes"][datasourceId]["isOpen"] = true
    //   originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
    //   originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isOpen"] = true
    // } else if (datasetId !== null && datasetId !== undefined) {
    //   originalData[envId]["isOpen"] = true
    //   originalData[envId]["childNodes"][datasourceId]["isOpen"] = true
    //   originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
    //   originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isShow"] = true

    //   prefix = `${envId}.${datasourceId}.${datasetId}`;
    //   lastRefresh = Object.values(chartData.issued_attributes[datasetId])[0]["refresh_time"]
    //   metricData = Object.values(chartData.dataset_level_data[datasetId])
    //   sectionName = "Dataset"
    //   datasetIds = [datasetId]
    //   let duplicateInfo =this.props.dataModule !== undefined &&  this.props.dataModule.info[datasourceId][prefix]
    //   if (duplicateInfo !== undefined) {
    //     let duplicateRowsList = duplicateInfo[`${DUPLICATE_METRIC}_duplicate_row`]
    //     if (duplicateRowsList) {
    //       duplicateRows = duplicateRowsList[duplicateRowsList.length - 1]
    //     }

    //   }
    //   attributeCount = Object.values(originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"]).length
    // } else if (datasourceId !== null && datasourceId !== undefined) {
    //   prefix = `${envId}.${datasourceId}`;
    //   sectionName = "Datasource"
    //   datasetIds = Object.keys(originalData[envId]["childNodes"][datasourceId]["childNodes"])
    //   datasetCount = datasetIds.length
    //   originalData[envId]["isOpen"] = true
    //   originalData[envId]["childNodes"][datasourceId]["isOpen"] = true
    //   originalData[envId]["childNodes"][datasourceId]["isShow"] = true
    //   for (const key of Object.keys(this.props.datasourceData)) {
    //     if (key.includes("Data")) {
    //       metricsOptions.push({ "label": key, "value": key })
    //     }

    //   }
    //   if (metricsOptions.length > 0) {
    //     let dataFromProps = this.props.datasourceData[metricsOptions[0].value]
    //     let data = _.cloneDeep(dataFromProps);
    //     let result = this.processDatasourceChart(data, datasourceId);
    //     driftOnMetricsChart = result["finalData"]
    //     filteredData = result["filteredData"]
    //   }

    //   let duplicateInfo = this.props.dataModule.info[datasourceId]
    //   for (let value of Object.values(duplicateInfo)) {
    //     let duplicateFiltered = value
    //     let duplicateRowsList = duplicateFiltered[`${DUPLICATE_METRIC}_duplicate_row`]
    //     if (duplicateRowsList) {
    //       duplicateRows = duplicateRowsList[duplicateRowsList.length - 1] + duplicateRows
    //     }
    //   }
    //   let recencyInfo = this.props.dataModule.recencyDetails[datasourceId]
    //   for (let value of Object.values(recencyInfo)) {
    //     let recencyFiltered = value
    //     let recencyList = recencyFiltered[`${DUPLICATE_METRIC}_time_value`]
    //     let latestRecency = 0
    //     if (recencyList) {
    //       latestRecency = recencyList[recencyList.length - 1]
    //     }
    //     if (latestRecency > 30) {
    //       recencyData = recencyData + 1
    //     }
    //   }

    // } else {
    //   prefix = `${envId}`;
    //   sectionName = "Environment"
    //   datasetCount = 0
    //   let total = originalData[envId]["childNodes"]
    //   datasourceCount = Object.keys(total).length
    //   for (const value of Object.values(total)) {
    //     datasetIds = datasetIds.concat(Object.keys(value["childNodes"]))
    //     datasetCount = datasetCount + datasetIds.length
    //   }
    //   envTableData = this.getEnvTableData(originalData[envId]["childNodes"], chartData)
    //   originalData[envId]["isShow"] = true
    //   originalData[envId]["isOpen"] = true
    // }
    // let datasetRow = 0;
    // if (["Dataset", "Attribute"].includes(sectionName)) {
    //   metricData = convertDataForListView(metricData, datasetName, datasourceName)
    //   for (let i = 0; i < metricData.length; i++) {
    //     if (metricData[i]["name"] === "Row Count") {
    //       datasetRow = metricData[i]["value"][metricData[i]["value"].length - 1]
    //     }
    //     //               if(metricData[i]["hasDrift"] === false) {
    //     //                 continue
    //     //               }

    //     selectedData.push(metricData[i]);
    //     metricsOptions.push({ "label": metricData[i]["name"], "value": metricData[i]["name"] });
    //   }

    // }

    // if (selectedData.length > 0) {
    //   driftOnMetricsChart = selectedData[0]
    //   if (driftOnMetricsChart["name"] === "Data Drift") {
    //     driftOnMetricsChart["boxPlotData"] = filterBoxPlotData(chartData["boxPlotData"])
    //   }
    //   filteredData = getChartFilterData(driftOnMetricsChart, this.state.startDate, this.state.endDate, "", false, false, 10)
    //   driftOnMetricsKey = sectionName + driftOnMetricsChart["name"]
    // }
    // if (currentIndex === null) {
    //   let currentData = this.props.filteredData.filter(x => x.type === type && x.id === id)
    //   currentIndex = this.props.filteredData.indexOf(currentData[0])
    // }

    // filteredValues.push(prefix)
    // if (this.state.isTreeSearch) {
    //   this.setState({ isTreeSearch: false, subString: "", filterSearch: "", newData: originalData, isDataChanged: !this.state.isDataChanged })
    // }
    // this.setState({
    //   envName: envName,
    //   currentIndex: currentIndex,
    //   envTableData: envTableData,
    //   filteredData: filteredData,
    //   selectedDataSource: datasourceId,
    //   datasetId: datasetId,
    //   recencyData: recencyData,
    //   envId: envId,
    //   duplicateRows: duplicateRows,
    //   attributeId: attributeId,
    //   datasetRow: datasetRow,
    //   selectedData: selectedData,
    //   lastRefresh: lastRefresh,
    //   showTreeView: false,
    //   metricsOptions: metricsOptions,
    //   sectionName: sectionName,
    //   datasetCount: datasetCount,
    //   attributeCount: attributeCount,
    //   datasourceCount: datasourceCount,
    //   isChartChanged: !this.state.isChartChanged,
    //   driftOnMetricsChart: driftOnMetricsChart,
    //   driftOnMetricsKey: driftOnMetricsKey,
    //   filteredValues: filteredValues,
    //   datasourceName: datasourceName,
    //   datasetName: datasetName,
    //   highlightedType: type,
    //   datasetIds: datasetIds,
    //   highlightedId: id,
    //   attributeName: attributeName
    // })
  }
  processDatasourceChart(data, datasourceId) {
    let finalData = null;
    let filteredData = null;
    let attributeName = null;
    let datasetName = null;
    if (data !== undefined) {
      for (const [key, value] of Object.entries(data)) {
        for (const [attribute, chartDataValues] of Object.entries(value)) {
          const attributeKeysSplit = attribute.split(".");
          if (datasourceId !== null) {
            if (attributeKeysSplit[1] !== datasourceId) {
              continue;
            }
          }

          let metaData = this.props.metaData[attribute];
          if (metaData === undefined) {
            metaData = this.props.metaData;
            const filtered = Object.keys(metaData)
              .filter(key => key.startsWith(attribute))
              .reduce((obj, key) => {
                obj[key] = metaData[key];
                return obj;
              }, {});
            metaData = filtered[Object.keys(filtered)[0]];
            if (metaData !== undefined) {
              metaData = metaData.split(".").slice(0, metaData.split(".").length - 1).join(".");
            }
          }
          if (metaData !== undefined) {
            const metadataSplit = metaData.split(".");

            let toolTiptopHeader;
            let keysSplitLength = attributeKeysSplit.length;

            // Skip attribute level charts for consistency related metrics
            if (keysSplitLength === 4 && REQUIRES_CONTRIBUTION_INSTEAD_OF_CHART.includes(key)) {
              continue;
            }

            if (keysSplitLength === 4) {
              datasetName = metadataSplit[2];
              attributeName = metadataSplit[metadataSplit.length - 1];
              toolTiptopHeader = attributeName;
            } else {
              datasetName = metadataSplit[2];
              toolTiptopHeader = datasetName;
            }
            if (chartDataValues["name"] === "Data Drift") {
              let boxPlotData = {}
              let statistics = {}
              let quantile = chartDataValues["boxplot_data"]
              if (quantile !== undefined && quantile !== null) {
                statistics["attribute_name"] = attributeName
                statistics["quantile"] = quantile
                statistics["drift_patterns"] = chartDataValues["drift_patterns"]
                statistics["time"] = chartDataValues["time"]
                if (attributeName !== null) {
                  boxPlotData["chart_level"] = "Attribute"
                } else {
                  boxPlotData["chart_level"] = "Dataset"
                }
                boxPlotData["statistics"] = [statistics]
                chartDataValues["boxPlotData"] = boxPlotData
                chartDataValues["chartType"] = "boxPlotZoomable"
              }
            }
            if (attributeName !== null) {
              chartDataValues["attribute_name"] = attributeName;
            }
            chartDataValues["datasetName"] = datasetName;
            chartDataValues["toolTiptopHeader"] = toolTiptopHeader;
            chartDataValues["data_set_id"] = attributeKeysSplit[2];
            chartDataValues["errorChart"] = true;
            chartDataValues["title"] = `${metadataSplit.join(" > ")} - ${chartDataValues.name}`;
            chartDataValues["data_source_name"] = metadataSplit[1];
            chartDataValues[DQ_CHART_POINTS] = chartDataValues["value"];

            let chartTypeData = getChartTypeForMonitorCharts(chartDataValues);
            chartDataValues["type"] = chartTypeData.chartPatternType;
            let hasError = chartTypeData.hasError;
            chartDataValues["hasDrift"] = hasError;

            // We are changing scale of all charts to min max scale
            // Part of fix for issue 1038
            chartDataValues["scale"] = MIN_MAX_SCALE;



            normalizeChartData(chartDataValues, DQ_CHART_POINTS);
            let chartValues = chartDataValues[DQ_CHART_POINTS];
            let drift_len = chartValues.length;

            if (drift_len === 0) {
              continue;
            }

            if (drift_len > 1) {
              chartDataValues["error_percentage"] = chartValues[(drift_len - 1)].toFixed(2);
              chartDataValues["last_error"] = chartValues[(drift_len - 2)].toFixed(2);
            } else if (drift_len === 1) {
              chartDataValues["error_percentage"] = chartValues[(drift_len - 1)].toFixed(2);
              chartDataValues["last_error"] = chartValues[(drift_len - 1)].toFixed(2);
            } else {
              chartDataValues["error_percentage"] = 0;
              chartDataValues["last_error"] = 0;
            }


          }
          finalData = chartDataValues

          if (finalData !== null) {
            if (finalData["name"] === "Data Drift") {
              finalData["boxPlotData"] = filterBoxPlotData(finalData["boxPlotData"])
            }
            filteredData = getChartFilterData(finalData, this.state.startDate, this.state.endDate)
            this.setState({ chartDatasetName: datasetName, chartAttributeName: attributeName })
            break
          }
        }


        if (finalData !== null) {
          break
        }
      }
    }
    let result = { "finalData": finalData, "filteredData": filteredData }
    return result
  }
  closeIcon() {
    this.setState({ leftSearchText: "", filterSearch: "", newData: {}, isDataChanged: !this.state.isDataChanged, isTreeSearch: false, searchTextFound: true, subString: null });
  }

  handleLeftSearchClear = () => {
    this.setState((prevState) => ({
      leftSearchText: "",
      filterSearch: "",
      isTreeSearch: false,
      searchTextFound: true,
      subString: null,
      newData: {},
      isDataChanged: !prevState.isDataChanged
    }));
  };

  handleChange = (event) => {
    const filterSearch = event.target.value || "";
    // Update input box state immediately so typing feels responsive
    this.setState({ filterSearch: filterSearch, leftSearchText: filterSearch });

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Debounce the heavy tree building logic
    this.searchTimeout = setTimeout(() => {
      const trimmedSearch = filterSearch.trim();

    if (!trimmedSearch) {
      this.setState((prevState) => ({
        newData: {},
        isDataChanged: !prevState.isDataChanged,
        isTreeSearch: false,
        searchTextFound: true,
        subString: null
      }));
      return;
    }

      // Ensure business_mapping (metaDataResponse) is loaded for KPI fallback during search
      if (this.props.ensureMetaDataResponse) {
        this.props.ensureMetaDataResponse();
      }

    if (this.props.watchListOpen) {
      this.setState({
        isTreeSearch: true,
        searchTextFound: true,
        subString: filterSearch
      });
      return;
    }

    if (this.props.getLeftPanelTreeDataResponse && this.props.LeftPanelTreeData) {
      const treeData = this.props.LeftPanelTreeData || {};
      const businessAreas = treeData.business_areas || [];
      const subjectAreas = treeData.subject_areas || {};
      const missingBusinessAreas = businessAreas.filter((ba) => {
        const baId = ba.value ?? ba.id ?? ba.business_id;
        return !(
          subjectAreas[baId] ||
          subjectAreas[String(baId)] ||
          subjectAreas[Number(baId)]
        );
      });

        if (missingBusinessAreas.length > 0) {
          // Fire off requests asynchronously without awaiting so we don't block the UI
          Promise.all(
            missingBusinessAreas.map((ba) => {
              const baId = ba.value ?? ba.id ?? ba.business_id;
              return this.props.getLeftPanelTreeDataResponse(
                baId,
                "",
                "",
                "",
                this.props.selectedWatchlistId
              );
            })
          ).catch(error => {
            console.error("Failed to prefetch left panel data for search", error);
          });
        }
      }

    const latestTreeData = this.props.LeftPanelTreeData && Object.keys(this.props.LeftPanelTreeData).length > 0
      ? this.props.LeftPanelTreeData
      : {};
    const treeObject = Object.keys(latestTreeData).length > 0
      ? this.buildNestedStructure(latestTreeData, this.props.selectedWatchlistId, false, filterSearch)
      : {};

      this.setState(prevState => ({
        newData: treeObject,
        isDataChanged: !prevState.isDataChanged,
        isTreeSearch: true,
        searchTextFound: Object.keys(treeObject).length > 0,
        subString: filterSearch
      }));
    }, 300);
  };
  getId(highlightedType, filteredItem) {
    if (highlightedType === "Environment") {
      return filteredItem["envId"]
    } else if (highlightedType === "Datasource") {
      return filteredItem["datasourceId"]
    } else if (highlightedType === "Dataset") {
      return filteredItem["datasetId"]
    } else {
      return filteredItem["attributeId"]
    }
  }
  changeNavigation(position) {
    let currentIndex = this.state.currentIndex
    let filteredItem;
    let disableUp;
    let disableDown;
    let filteredData = this.props.filteredData
    if (currentIndex - 1 === 0) {
      disableUp = true
    } else {
      disableUp = false
    }
    if (currentIndex === (filteredData.length - 2)) {
      disableDown = true
    } else {
      disableDown = false
    }

    let highlightedType;
    let highlightedId;
    if (position === "down") {
      filteredItem = filteredData[currentIndex + 1]
      currentIndex = currentIndex + 1
      if (filteredItem !== undefined) {
        highlightedType = filteredItem["type"]
        highlightedId = this.getId(highlightedType, filteredItem)
      }
    } else {
      filteredItem = filteredData[currentIndex - 1]
      currentIndex = currentIndex - 1
      if (filteredItem !== undefined) {
        highlightedType = filteredItem["type"]
        highlightedId = this.getId(highlightedType, filteredItem)
      }
    }
    let envName = filteredItem["envName"];
    let datasourceName = filteredItem["datasourceName"]
    let datasetName = filteredItem["datasetName"]
    let attributeName = filteredItem["attributeName"]
    if (highlightedType === "Datasource") {
      datasourceName = filteredItem["name"]
    } else if (highlightedType === "Dataset") {
      datasetName = filteredItem["name"]
    } else if (highlightedType === "Attribute") {
      attributeName = filteredItem["name"]
    } else if (highlightedType === "Environment") {
      envName = filteredItem["name"]
    }
    this.changeData(envName, datasourceName, datasetName, attributeName,
      filteredItem["envId"], filteredItem["datasourceId"],
      filteredItem["datasetId"], filteredItem["attributeId"], highlightedId, highlightedType, currentIndex)
    this.setState({ disableUp: disableUp, disableDown: disableDown })
  }

  reset() {
    this.setState({ envName: "" });
    this.props.clearSearch();
  }

  getIcon(type) {
    if (type === "Environment") {
      return faServer;
    } else if (type === "Datasource") {
      return faDatabase;
    } else if (type === "Dataset") {
      return faLayerGroup;
    } else {
      return faTag;
    }
  }


  getFiltered(data, text, childNodes, original) {
    if (text === original) {
      data["isOpen"] = true
    }
    if (childNodes !== undefined) {
      let data1 = Object.values(childNodes)
      for (let i = 0; i < data1.length; i++) {
        this.getFiltered(data1[i], text, data1[i]["childNodes"], data1[i]["name"])
      }
    }
    else {
      return
    }

  }

  handleTreeViewButton() {
    this.setState({ showTreeView: !this.state.showTreeView })
    setTimeout(function () {
      if ($("#tree-view").hasClass("show")) {
        $('body').addClass("overflow-hidden");
      } else {
        $('body').removeClass("overflow-hidden");
      }
    }, 500);
  }
buildNestedStructure(data, watch_list_id, watchListOpen = false, searchText = null) {
  if (!data || Object.keys(data).length === 0) return {};

  const { business_areas = [], subject_areas = {}, kpis = {}, models = {} } = data;
  let result = {};
  let lowerSearchText = searchText ? searchText.toLowerCase().trim() : "";
  let isSearchActive = !!lowerSearchText;
  let matchesSearch = (text) => text && text.toLowerCase().includes(lowerSearchText);
  const getLookup = (...vals) => vals.find(v => v !== undefined && v !== null && v !== "");

  // If no business areas loaded yet, fallback to metaDataResponse
  if (business_areas.length === 0 && isSearchActive) {
    const metaBAs = this?.props?.metaDataResponse?.business_area;
    if (Array.isArray(metaBAs) && metaBAs.length > 0) {
      business_areas.push(...metaBAs.map(ba => ({
        label: ba.business_name || ba.name,
        name: ba.business_name || ba.name,
        value: ba.business_id ?? ba.id,
        id: ba.business_id ?? ba.id
      })));
    }
  }

  // --------------------------------------------------------------------
  // GLOBAL FLAGS - Only FIRST KPI and FIRST DATASET inside that KPI
  // --------------------------------------------------------------------
  let globalKPIFound = false;
  let globalDatasetFound = false;
  // let globalDatasourceFound = false;  

  // --------------------------------------------------------------------
  // ATTRIBUTE NODE
  // --------------------------------------------------------------------
  const createAttributeNode = (attr, includeAllChildren = false) => {
    const title = attr.label || attr.name || "Attribute";
    const attributeMatches = includeAllChildren || matchesSearch(title);
    let hasAttributeMetrics = false;

    const node = {
      title,
      type: "Attribute",
      id: attr.id ?? attr.value ?? null,
      error: attr.error ?? false,
      noChartPoints: attr.no_chart_points || false,
      value: attr.value ?? null,
      childNodes: [],
      isOpen: false,
      isShow: true
    };

    if (!watchListOpen) {
      let attrMetrics = Array.isArray(attr.metrics) ? [...attr.metrics] : [];
      let attrCustomMetrics = Array.isArray(attr.custom_metrics) ? [...attr.custom_metrics] : [];

      if (isSearchActive && !includeAllChildren && !attributeMatches) {
        attrMetrics = attrMetrics.filter((m) => matchesSearch(m.metrics_name || m.name));
        attrCustomMetrics = attrCustomMetrics.filter((m) => matchesSearch(m.metrics_name || m.name));
      }
    // ---- Attribute → Metrics ----
      if (attrMetrics.length > 0) {
        hasAttributeMetrics = true;
        node.childNodes.push({
          title: "Metrics",
          type: "Metrics",
          id: `attr_metrics_${node.id}`,
          isOpen: !isSearchActive,
          isShow: true,
          childNodes: attrMetrics.map((m) => ({
            title: m.metrics_name || m.name,
            type: "Metric",
            id: "attribute_" + m.metrics_id,
            latest: m.latest ?? null,
            previous: m.previous ?? null,
            error: m.error ?? false,
            childNodes: [],
            isShow: true
          }))
        });
      }
    // ---- Attribute → Custom Metrics ----
      if (attrCustomMetrics.length > 0) {
        hasAttributeMetrics = true;
        node.childNodes.push({
          title: "Custom Metrics",
          type: "Custom Metrics",
          id: `attr_custom_${node.id}`,
          isOpen: !isSearchActive,
          isShow: true,
          childNodes: attrCustomMetrics.map((m) => ({
            title: m.metrics_name || m.name,
            type: "CustomMetric",
            id: "attribute_" + m.metrics_id,
            latest: m.latest ?? null,
            previous: m.previous ?? null,
            error: m.error ?? false,
            childNodes: [],
            isShow: true
          }))
        });
      }
    }

    if (isSearchActive && !includeAllChildren && !attributeMatches && !hasAttributeMetrics) {
      return null;
    }

    return node;
  };

  // --------------------------------------------------------------------
  // DATASET NODE
  // --------------------------------------------------------------------
  const createDatasetNode = (dataset, attrList = [], isFirstDataset = false, includeAllChildren = false, integrationName = "", datasourceId = null) => {
    const datasetTitle = dataset.label || dataset.name || "Dataset";
    const datasetNameMatched = includeAllChildren || matchesSearch(datasetTitle);
    let datasetHasMatch = false;
    let hasDatasetMetrics = false;

    const node = {
      title: datasetTitle,
      type: "Dataset",
      id: dataset.id ?? dataset.value ?? null,
      error: dataset.error ?? false,
      firstDataset: isFirstDataset,
      integrationName: integrationName,
      datasourceName: integrationName,
      datasourceId: datasourceId,
      childNodes: [],
      isOpen: false,
      isShow: true
    };

    if (!watchListOpen) {
      let metrics = Array.isArray(dataset.metrics) ? [...dataset.metrics] : [];
      let customMetrics = Array.isArray(dataset.custom_metrics) ? [...dataset.custom_metrics] : [];

      if (isSearchActive && !includeAllChildren && !datasetNameMatched) {
        metrics = metrics.filter((m) => matchesSearch(m.metrics_name || m.name));
        customMetrics = customMetrics.filter((m) => matchesSearch(m.metrics_name || m.name));
      }

      if (metrics.length > 0) {
        hasDatasetMetrics = true;
        datasetHasMatch = true;
        node.childNodes.push({
          title: "Metrics",
          type: "Metrics",
          id: `metrics_ds_${node.id}`,
          isOpen: false,
          isShow: true,
          childNodes: metrics.map((m) => ({
            title: m.metrics_name || m.name,
            type: "Metric",
            id: "dataset_" + m.metrics_id,
            latest: m.latest ?? null,
            previous: m.previous ?? null,
            error: m.error ?? false,
            childNodes: [],
            isShow: true
          }))
        });
      }

      if (customMetrics.length > 0) {
        hasDatasetMetrics = true;
        datasetHasMatch = true;
        node.childNodes.push({
          title: "Custom Metrics",
          type: "CustomMetrics",
          id: `custom_ds_${node.id}`,
          isOpen: false,
          isShow: true,
          childNodes: customMetrics.map((m) => ({
            title: m.metrics_name || m.name,
            type: "CustomMetric",
            id: "dataset_" + m.metrics_id,
            latest: m.latest ?? null,
            previous: m.previous ?? null,
            error: m.error ?? false,
            childNodes: [],
            isShow: true
          }))
        });
      }
    }

    const forceIncludeAttributes = !isSearchActive && (includeAllChildren || datasetNameMatched);
    const seenAttributeIds = new Set();
    (attrList || []).forEach((attr) => {
      const attrNode = createAttributeNode(attr, forceIncludeAttributes);
      if (attrNode) {
        seenAttributeIds.add(attrNode.id);
        node.childNodes.push(attrNode);
        datasetHasMatch = true;
      }
    });

    if (forceIncludeAttributes && Array.isArray(attrList)) {
      attrList.forEach((attr) => {
        const attrId = attr.id ?? attr.value ?? null;
        if (!seenAttributeIds.has(attrId)) {
          const attrNode = createAttributeNode(attr, true);
          if (attrNode) node.childNodes.push(attrNode);
        }
      });
    }

    const shouldShowDataset = !isSearchActive || includeAllChildren || datasetNameMatched || datasetHasMatch || hasDatasetMetrics;
    if (!shouldShowDataset) return null;

    if (isSearchActive && (includeAllChildren || datasetNameMatched || datasetHasMatch || hasDatasetMetrics)) {
      node.isOpen = true;
    }

    return node;
  };
  // --------------------------------------------------------------------
  // KPI NODE
  // --------------------------------------------------------------------
  const createKPINode = (kpi, includeAllChildren = false) => {
    const title = kpi.label || kpi.KPI_name || kpi.kpi_name || kpi.name || "KPI";
    const kpiMatches = includeAllChildren || matchesSearch(title);
    const isFirstKPI = !globalKPIFound;
    if (isFirstKPI) globalKPIFound = true;

    const node = {
      title,
      type: "KPI",
      id: kpi.value ?? kpi.id ?? null,
      error: kpi.error ?? false,
      latest: kpi.latest ?? null,
      previous: kpi.previous ?? null,
      firstKPI: isFirstKPI,
      childNodes: [],
      isOpen: false,
      isShow: true
    };
  // -----------------------------
  // KPI → Integrations
  // -----------------------------
    if (Array.isArray(kpi.integrations)) {
      kpi.integrations.forEach((integration) => {
        const dsTitle = integration.label || "Integration";
        const datasourceMatches = includeAllChildren || matchesSearch(dsTitle);

      // -----------------------------
      // Integration → Datasets
      // -----------------------------
        if (kpi.datasets && kpi.datasets[integration.value]) {
          kpi.datasets[integration.value].forEach((ds) => {
            const isFirstDataset = !globalDatasetFound;
            if (isFirstDataset) globalDatasetFound = true;

            const datasetId = ds.value ?? ds.id;
            const attrList = (kpi.attributes && (
              kpi.attributes[datasetId] ||
              kpi.attributes[String(datasetId)] ||
              kpi.attributes[Number(datasetId)]
            )) || [];

            const dsNode = createDatasetNode(ds, attrList, isFirstDataset, includeAllChildren || datasourceMatches || kpiMatches, dsTitle, integration.value ?? null);
            if (dsNode) {
              node.childNodes.push(dsNode);
            }
          });
        }
      });
    }

    const shouldShowKPI = !isSearchActive || includeAllChildren || kpiMatches || node.childNodes.length > 0;
    if (!shouldShowKPI) return null;

    if (isSearchActive && (includeAllChildren || kpiMatches || node.childNodes.length > 0)) {
      node.isOpen = true;
    }

    return node;
  };

  // --------------------------------------------------------------------
  // MODEL NODE
  // --------------------------------------------------------------------
  const createModelNode = (model, includeAllChildren = false) => {
    const title = model.label || model.model_name || model.name || "Model";
    const modelMatches = includeAllChildren || matchesSearch(title);

    const node = {
      title,
      type: "Model",
      id: model.value ?? model.id ?? null,
      error: model.error ?? false,
      childNodes: [],
      isOpen: false,
      isShow: true
    };

    if (Array.isArray(model.integrations)) {
      model.integrations.forEach((integration) => {
        const dsTitle = integration.label || "Integration";
        const datasourceMatches = includeAllChildren || matchesSearch(dsTitle);


        if (model.datasets && model.datasets[integration.value]) {
          model.datasets[integration.value].forEach((ds) => {
            const isFirstDataset = !globalDatasetFound;
            if (isFirstDataset) globalDatasetFound = true;

            const datasetId = ds.value ?? ds.id;
            const attrList = (model.attributes && (
              model.attributes[datasetId] ||
              model.attributes[String(datasetId)] ||
              model.attributes[Number(datasetId)]
            )) || [];

            const dsNode = createDatasetNode(ds, attrList, isFirstDataset, includeAllChildren || datasourceMatches || modelMatches, dsTitle, integration.value ?? null);
            if (dsNode) {
              node.childNodes.push(dsNode);
            }
          });
        }
      });
    }

    const shouldShowModel = !isSearchActive || includeAllChildren || modelMatches || node.childNodes.length > 0;
    if (!shouldShowModel) return null;

    if (isSearchActive && (includeAllChildren || modelMatches || node.childNodes.length > 0)) {
      node.isOpen = true;
    }

    return node;
  };
  // --------------------------------------------------------------------
  // SUBJECT AREA NODE
  // --------------------------------------------------------------------
  const createSubjectAreaNode = (baId, saId, sa, isFirstSubjectArea = false, includeAllChildren = false) => {
    const title = sa.label || sa.name || sa.subject_name || sa.subject_area_name || `Subject Area ${saId}`;
    const subjectMatches = includeAllChildren || matchesSearch(title);
    const node = {
      title,
      type: "SubjectArea",
      id: sa.value ?? sa.id ?? sa.subject_id ?? saId,
      firstSubjectArea: isFirstSubjectArea,
      childNodes: [],
      isOpen: false,
      isShow: true,
      _isStub: sa._isStub
    };

    const kpiKey = watch_list_id ? `${baId}_${saId}` : saId;
    let saKPIs = kpis[kpiKey] || kpis[String(kpiKey)] || kpis[Number(kpiKey)] ||
      kpis[saId] || kpis[String(saId)] || kpis[Number(saId)] || [];

    // If no KPIs loaded yet for this SA (lazy load hasn't fired), fall back to
    // business_mapping (metaDataResponse) which has ALL KPIs for name-based search
    if (saKPIs.length === 0 && isSearchActive) {
      const metaKpis = this.props.metaDataResponse?.kpi;
      if (metaKpis) {
        const fallback = metaKpis[saId] || metaKpis[String(saId)] || metaKpis[Number(saId)];
        if (Array.isArray(fallback) && fallback.length > 0) {
          // Normalize to the shape createKPINode expects: { label/name, value/id }
          saKPIs = fallback.map(k => ({
            label: k.name || k.label,
            name: k.name || k.label,
            value: k.id ?? k.value,
            id: k.id ?? k.value,
            error: k.error ?? false,
            latest: null,
            previous: null,
            integrations: [],
            datasets: {},
            attributes: {},
            // Mark as stub so the click handler triggers lazy-load + real click
            _isStub: true,
            _saId: saId,
            _baId: baId
          }));
        }
      }
    }

    if (saKPIs.length) {
      const kpiWrapper = {
        title: "KPIs",
        type: "KPIs",
        id: `kpis_${node.id}`,
        latest: saKPIs.length > 0 ? (saKPIs[0].latest ?? null) : null,
        previous: saKPIs.length > 0 ? (saKPIs[0].previous ?? null) : null,
        childNodes: [],
        isOpen: false,
        isShow: true
      };

      saKPIs.forEach((kpi) => {
        const kpiNode = createKPINode(kpi, includeAllChildren || subjectMatches);
        if (kpiNode) kpiWrapper.childNodes.push(kpiNode);
      });

      if (!isSearchActive || includeAllChildren || kpiWrapper.childNodes.length > 0 || subjectMatches) {
        if (isSearchActive && (includeAllChildren || kpiWrapper.childNodes.length > 0 || subjectMatches)) {
          kpiWrapper.isOpen = true;
        }
        node.childNodes.push(kpiWrapper);
      }
    }

    const modelKey = watch_list_id ? `${baId}_${saId}` : saId;
    const saModels = models[modelKey] || models[String(modelKey)] || models[Number(modelKey)] || [];
    const modelWrapper = {
      title: "Models",
      type: "Models",
      id: `models_${node.id}`,
      childNodes: [],
      isOpen: false,
      isShow: true
    };
    const modelsTitleMatches = matchesSearch("Models");

    saModels.forEach((model) => {
      const modelNode = createModelNode(model, includeAllChildren || subjectMatches);
      if (modelNode) modelWrapper.childNodes.push(modelNode);
    });

    if (!isSearchActive || includeAllChildren || modelWrapper.childNodes.length > 0 || subjectMatches || modelsTitleMatches) {
      if (isSearchActive && (includeAllChildren || modelWrapper.childNodes.length > 0 || subjectMatches)) {
        modelWrapper.isOpen = true;
      }
      node.childNodes.push(modelWrapper);
    }

    const shouldShowSubject = !isSearchActive || includeAllChildren || subjectMatches || node.childNodes.length > 0;
    if (!shouldShowSubject) return null;

    if (isSearchActive && (includeAllChildren || subjectMatches || node.childNodes.length > 0)) {
      node.isOpen = true;
    }

    return node;
  };

  business_areas.forEach((ba, baIndex) => {
    const businessAreaKey = getLookup(ba.value, ba.id, ba.business_id);
    const title = ba.label || ba.name || ba.business_name || `Business Area ${businessAreaKey}`;
    const businessMatches = matchesSearch(title);
    const baNode = {
      title,
      type: "BusinessArea",
      id: businessAreaKey ?? null,
      firstBusinessArea: baIndex === 0,
      childNodes: [],
      isOpen: false,
      isShow: true
    };

    let saList = Object.values(
      subject_areas[businessAreaKey] ||
      subject_areas[String(businessAreaKey)] ||
      subject_areas[Number(businessAreaKey)] ||
      {}
    );

    // If no SAs loaded yet for this BA, fallback to metaDataResponse for search
    if (saList.length === 0 && isSearchActive) {
      const metaSAs = this.props.metaDataResponse?.subject_area;
      if (metaSAs) {
        const fallback = metaSAs[businessAreaKey] || metaSAs[String(businessAreaKey)] || metaSAs[Number(businessAreaKey)];
        if (Array.isArray(fallback) && fallback.length > 0) {
          saList = fallback.map(sa => ({
            label: sa.subject_name || sa.name || sa.label,
            name: sa.subject_name || sa.name || sa.label,
            value: sa.subject_id ?? sa.id ?? sa.value,
            id: sa.subject_id ?? sa.id ?? sa.value,
            _isStub: true
          }));
        }
      }
    }

    saList.forEach((sa, saIndex) => {
      const subjectAreaKey = getLookup(sa.value, sa.id, sa.subject_id, saIndex);
      const saNode = createSubjectAreaNode(businessAreaKey, subjectAreaKey, sa, saIndex === 0, businessMatches);
      if (saNode) baNode.childNodes.push(saNode);
    });

    const shouldShowBusiness = !isSearchActive || businessMatches || baNode.childNodes.length > 0;
    if (shouldShowBusiness) {
      if (isSearchActive && (businessMatches || baNode.childNodes.length > 0)) {
        baNode.isOpen = true;
      }
      result[`ba_${businessAreaKey}`] = baNode;
    }
  });

  return result;
}
buildWatchlistTreeFromMeta(metaData, searchText = null) {
  if (!metaData) return {};

  const result = {};
  const { business_area = [], subject_area = {}, kpi = {}, models = {} } = metaData;
  const lowerSearchText = searchText ? searchText.toLowerCase().trim() : "";
  const isSearchActive = !!lowerSearchText;
  const matchesSearch = (text) => !isSearchActive || (text && text.toLowerCase().includes(lowerSearchText));

  business_area.forEach((ba, baIndex) => {
    const businessTitle = ba.business_name || "Business Area";
    const businessMatches = matchesSearch(businessTitle);
    const baNode = {
      title: businessTitle,
      type: "BusinessArea",
      id: ba.business_id,
      firstBusinessArea: baIndex === 0,
      childNodes: [],
      isOpen: false
    };

    const saList =
      subject_area?.[ba.business_id] ||
      subject_area?.[String(ba.business_id)] ||
      subject_area?.[Number(ba.business_id)] ||
      [];


    saList.forEach((sa, saIndex) => {
      const subjectTitle = sa.name || "Subject Area";
      const subjectMatches = businessMatches || matchesSearch(subjectTitle);
      const saNode = {
        title: subjectTitle,
        type: "SubjectArea",
        id: sa.id,
        business_id: ba.business_id,
        firstSubjectArea: saIndex === 0,
        childNodes: [],
        isOpen: false
      };
      let hasMatchedChildren = false;

      // -------- KPIs --------
      // Try both numeric and string keys for kpi lookup since business_mapping keys may vary
      const saKpis = kpi?.[sa.id] || kpi?.[String(sa.id)] || kpi?.[Number(sa.id)] || [];
      if (saKpis.length) {
        const kpiWrapper = {
          title: "KPIs",
          type: "KPIs",
          id: `kpis-${sa.id}`,   // stable static key
          subject_area_id: sa.id,
          childNodes: [],
          isOpen: false
        };

        saKpis.forEach((kpiItem) => {
          const kpiTitle = kpiItem.name || "KPI";
          if (businessMatches || subjectMatches || matchesSearch(kpiTitle)) {
            kpiWrapper.childNodes.push({
              title: kpiTitle,
              type: "KPI",
              id: kpiItem.id,   // backend ID
              error: !!kpiItem.error,
              childNodes: []
            });
          }
        });

        if (kpiWrapper.childNodes.length) {
          hasMatchedChildren = true;
          if (isSearchActive) {
            kpiWrapper.isOpen = true;
          }
          saNode.childNodes.push(kpiWrapper);
        }
      }

      // -------- MODELS --------
      const saModels = models?.[sa.id] || models?.[String(sa.id)] || models?.[Number(sa.id)] || [];
      if (saModels.length) {
        const modelWrapper = {
          title: "Models",
          type: "Models",
          id: `models-${sa.id}`,
          subject_area_id: sa.id,  // stable static key
          childNodes: [],
          isOpen: false
        };

        saModels.forEach(modelItem => {
          const modelTitle = modelItem.name || "Model";
          if (businessMatches || subjectMatches || matchesSearch(modelTitle)) {
            modelWrapper.childNodes.push({
              title: modelTitle,
              type: "Model",
              id: modelItem.id,   // backend ID
              error: !!modelItem.error,
              childNodes: []
            });
          }
        });

        if (modelWrapper.childNodes.length) {
          hasMatchedChildren = true;
          if (isSearchActive) {
            modelWrapper.isOpen = true;
          }
          saNode.childNodes.push(modelWrapper);
        }
      }

      if (!isSearchActive || subjectMatches || hasMatchedChildren) {
        if (isSearchActive && (subjectMatches || hasMatchedChildren)) {
          saNode.isOpen = true;
        }
        baNode.childNodes.push(saNode);
      }
    });

    if (!isSearchActive || businessMatches || baNode.childNodes.length) {
      if (isSearchActive && (businessMatches || baNode.childNodes.length)) {
        baNode.isOpen = true;
      }
      //result[ba.business_id] = baNode;
      result[`ba_${ba.business_id}`] = baNode;
    }
  });

  return result;
}


filterNodeByType(node, checkedStates) {
  if (!node) return null;

  const nodeKey = `${node.type}-${node.id}`;

  const isChecked = checkedStates[nodeKey]?.checked;

  // Recursively filter children first
  let filteredChildren = [];
  if (node.childNodes && node.childNodes.length > 0) {
    filteredChildren = node.childNodes
      .map((child) => this.filterNodeByType(child, checkedStates))
      .filter(Boolean);
  }


  if (isChecked || filteredChildren.length > 0) {
    return { ...node, childNodes: filteredChildren };
  }

  // Otherwise, exclude this node
  return null;
}
//     normalizeIncidentData(data) {
//       if (!data) return null;
//       return {
//         integration_id: data.integration_id,
//         dataset_id: data.dataset_id,
//         attribute_id: data.attribute_id,
//         metrics_id: data.metrics_id,
//         business_id: data.business_id,
//         subject_id: data.subject_id,
//         kpi_id: data.kpi_id,
//         env_id: data.env_id,
//         target_type: data.target_type || data.type
//         };
//     }


//       return {
//         expanded: clonedNode.isOpen,
//         childNode: clonedNode
//       };
//     };

//     const newData = {};

//     Object.keys(data).forEach(key => {
//       const { childNode } = expandNode(data[key]);
//       newData[key] = childNode;
//     });

//     return newData;
//   }//search in left panel 
  render() {
    // let data = []
    // if (Object.values(this.state.newData).length > 0) {
    //   data = Object.values(this.state.newData)
    // } else {
    //   data = this.state.data !== undefined && this.state.data !== null ? Object.values(this.state.data) : [];
    // }
// console.log("this.props.LeftPanelTreeData",this.props.LeftPanelTreeData);
let data = [];
const searchText = this.state.leftSearchText;
const watchListSearchText = this.props.saveWatchListSearchText || "";
const dataSearchText = this.props.watchListOpen ? watchListSearchText : searchText;
const nodeSearchText = this.props.watchListOpen ? watchListSearchText : (this.state.leftSearchText || this.state.subString);
const isSearchHappened = this.props.watchListOpen
  ? Boolean(watchListSearchText.trim())
  : Boolean(this.state.leftSearchText && this.state.leftSearchText.trim());

if (this.props.watchListOpen) {
  //  Watchlist OPEN → show full metadata
  if (this.props.metaDataResponse && Object.keys(this.props.metaDataResponse).length > 0) {
    data = this.buildWatchlistTreeFromMeta(this.props.metaDataResponse, dataSearchText);
  }
} else {
  //  Watchlist CLOSED → show watchlist tree
  if (this.props.LeftPanelTreeData && Object.keys(this.props.LeftPanelTreeData).length > 0) {
    data = this.buildNestedStructure(this.props.LeftPanelTreeData, this.props.selectedWatchlistId, false, dataSearchText);
  }
}

// if (this.props.viewIncidentData) {
//   data = this.filterResultByIncidentData(data, this.props.viewIncidentData);
// }

const dataValues = Object.values(data || {});
const treeRenderKey = this.props.watchListOpen
  ? `watchlist-${dataSearchText}`
  : this.state.isDataChanged;

// console.log("tree data", data);



// if (this.props.selectedWatchlistName && this.props.selectedWatchlistName.toLowerCase() !== "my daily followup") {
//   const checkedStates = this.props.checkedStates;

//   // Filter each business area individually
//   Object.keys(data).forEach((businessAreaKey) => {
//     const filteredBA = this.filterNodeByType(data[businessAreaKey], checkedStates);
//     if (filteredBA) {
//       data[businessAreaKey] = filteredBA;
//     } else {
//       delete data[businessAreaKey]; // remove entire BA if nothing checked
//     }
//   });
// }

// const fullTree = this.buildNestedStructure(convertData);
// const filteredTree = this.filterNestedStructure(fullTree, this.props.checkedboxes);

// console.log("filteredTree",filteredTree);



    let profileData = this.state.profileData;
    let keys = ["avg", "min", "max", "std"]
    if (profileData !== undefined && profileData !== null) {
      for (let i = 0; i < keys.length; i++) {
        if (typeof (profileData[keys[i]]["drift"]) === "number") {
          profileData[keys[i]]["drift"] = parseFloat(profileData[keys[i]]["drift"].toFixed(4))
        }
        if (typeof (profileData[keys[i]]["value"]) === "number") {
          profileData[keys[i]]["value"] = parseFloat(profileData[keys[i]]["value"].toFixed(4))
        }
      }
    }

    for (let [key] of Object.entries(activeItem)) {
      activeItem[key] = "breadcrumb-item";
    }
    activeItem[this.state.highlightedType] = 'breadcrumb-item active'
    let sizeData = 0
    let filtered = this.props.dataModule !== undefined && this.props.dataModule.dataSize.filter(x => (this.state.datasetIds.includes(x.data_set_id.toString())))
    for (let i = 0; i < filtered.length; i++) {
      sizeData = sizeData + filtered[i]["size"]

    }
    // let showTreeView = this.state.showTreeView
    sizeData = getConvertedSize(sizeData)
    // setTimeout(function(){
    //     if(document.getElementById('dqInfoId')){
    //        if(document.getElementById('dqInfoId').clientHeight < 500){
    //             if(showTreeView){
    //                $("#tree-view .custom-scrollbar").height("calc(100% - 112px)");
    //             }else{
    //                $("#tree-view .custom-scrollbar").height(500);
    //             }
    //        }else{
    //             $("#tree-view .custom-scrollbar").height(document.getElementById('dqInfoId').clientHeight);
    //        }
    //     }
    //     }, 500);

    // setTimeout(function () {
    //   $("#tree-view").height("100%");
    // }, 500);
    return (<><div className="qd_tree-wrapper" id="tree-view">
      <div className="qd_tree-view-container">
        {!this.state.showCustomCheckbox ?
          <div className="qd_tree-view-top">
            <div className="title">
              <div className="title-left">
                <label>Main Source</label>
              </div>
              <div className="title-right">
                <ul>
                  <li>New</li>
                  <li>Old</li>
                </ul>
              </div>
            </div>
            <div className="qd-search-bar has-btn-close qd-search-bar--bg-gray">
              <div className="input-group">
                <div className="input-group-prepend">
                  <button id="button-addon4" type="button" className="btn"><FontAwesomeIcon icon={faSearch}/></button>
                </div>
                <input type="search" placeholder="Search..." className="form-control"  onChange={this.handleChange} value={this.state.leftSearchText}/>
              </div>
              {this.state.leftSearchText && <button className="btn btn-clear" title="clear" onClick={this.handleLeftSearchClear}><i className="icon-close"></i></button>}
            </div>
          </div> 
         : ''} 
        
        {this.state.isRedirect && !(this.state.isTreeSearch) ?
          <div className="search-controls-section">
            <div className="qd_tree-search-controls">
              <p><strong>  {this.props.searchCount}</strong> results</p>
              <div className="search-actions">
                {this.props.filteredData ? <><button disabled={this.state.disableUp || this.props.filteredData.length <= 1} className="btn" id="up" onClick={this.changeNavigation.bind(this, "up")} title="Previous Match (&#8593; Up Arrow)">
                  <i className="icon_arrow-up"></i></button>
                  <span className="icon-divider"></span>
                  <button disabled={this.state.disableDown || this.props.filteredData.length <= 1} className="btn" id="down" onClick={this.changeNavigation.bind(this, "down")} title="Next Match (&#8595; Down Arrow)"><i className="icon_arrow-down"></i></button>
                </>
                  :
                  ""
                }
                <button className="btn" title="Close (Escape)" onClick={this.reset}><i className="icon_cross"></i></button>
              </div>
            </div>
          </div>
          :
          ""
        }
        <Scrollbars className="custom-scrollbar"
          autoHeightMin={0}
          autoHeightMax={200}
          thumbMinSize={30}
          universal={true}
        >
          <div style={{paddingBottom: "70px"}}>
          <ul className="qd_tree-view vertical-lined-tree-view" key={treeRenderKey}>
            {dataValues.length === 0 || (!this.state.searchTextFound && this.state.isTreeSearch) ?
              <div className="alert_notree-search-match">
                <Image
                  src="icon_exclamation_gray"
                />
                <p>No matches found for your search</p>
              </div>
              :
            dataValues.map(({ id, title, childNodes, type, isOpen, isShow, firstBusinessArea }) => (
                  <Node
                    key={id}
                    isRedirect={this.state.isRedirect || this.state.isTreeSearch}
                    envName={title}
                    isTreeSearch={this.state.isTreeSearch}
                    subString={nodeSearchText}
                    title={title}
                    type={type}
                    isSearchHappened={isSearchHappened}
                    id={id}
                    childNodes={Object.values(childNodes)}
                    isOpen={isOpen}
                    isShow={isShow}
                    firstBusinessArea={firstBusinessArea}
                    highlightedId={this.state.highlightedId}
                    highlightedType={this.state.highlightedType}
                    changeData={this.changeData} 
                    showCustomCheckbox={this.state.showCustomCheckbox}
                    isNodeHasActions = {this.state.isNodeHasActions}
                    renderchartView={this.props.renderchartView}
                    handleSaveWatchlistCheckboxChange = {this.props.handleSaveWatchlistCheckboxChange}
                    checkedStates = {this.props.checkedStates}
                    arrowIndicator={this.props.arrowIndicator}
                    newValue={this.props.newValue}
                    oldValue={this.props.oldValue}
                    selectedWatchlistName = {this.props.selectedWatchlistName}
                    checkedboxes = {this.props.checkedboxes}
                    getLeftPanelTreeDataResponse = {this.props.getLeftPanelTreeDataResponse}
                    watchListOpen = {this.props.watchListOpen}
                    selectedWatchlistId = {this.props.selectedWatchlistId}

                    />
              ))}

          </ul>
          </div>
        </Scrollbars>
      </div>
    </div>
      <div className="qd_tree-overlay"></div>
    </>);

  }
}

export default Leftpanel;


class Node extends React.Component {
  constructor(props) {
    super(props);
    let datasourceName = "";
    let datasourceId = null;
    let datasetName = "";
    let datasetId = null;
    let attributeName = "";
    let attributeId = null;
    let envId = null;
    let envName = "";
    let KPI_name=""
    // let BusinessArea= null
    let BusinessAreaId = ""
    // let SubjectArea = null
    let SubjectAreaId = "";
    let kpiId = "";
    if (props.type === "Datasource") {
      datasourceName = props.title;
      datasourceId = props.id;
    } else if (props.type === "Dataset") {
      datasetName = props.title;
      datasetId = props.id;
    } else if (props.type === "Attribute") {
      attributeName = props.title;
      attributeId = props.id;
    }
    else if (props.type === "KPI") {
      
      KPI_name = props.title;      
      kpiId = props.id;
    }
    else if (props.type === "BusinessArea") {
      
      // BusinessArea = props.title;      
      BusinessAreaId = props.id;
    } 
      else if (props.type === "SubjectArea") {
      
      // SubjectArea = props.title;      
      SubjectAreaId = props.id;
    } 
    else {
      envId = props.id
      envName = props.title
    }
    let highlightedClass = ""
    let listClassName = ""
    if (this.props.highlightedId != null && String(this.props.highlightedId) === String(this.props.id) && this.props.highlightedType === this.props.type) {
      highlightedClass = "search-highlight-selected"
      listClassName = "active"
    }

    this.state = {
      isOpen: this.props.isOpen && !this.props.isChanged,
      isShow: this.props.isShow,
      envName: envName === "" ? this.props.envName : envName,
      datasourceName: datasourceName === "" ? this.props.datasourceName : datasourceName,
      datasetName: datasetName === "" ? this.props.datasetName : datasetName,
      attributeName: attributeName,
      KPI_name:KPI_name === "" ? this.props.KPI_name : KPI_name,
      envId: envId === null ? this.props.envId : envId,
      highlightedId: this.props.highlightedId,
      highlightedType: this.props.highlightedType,
      datasourceId: datasourceId === null ? this.props.datasourceId : datasourceId,
      datasetId: datasetId === null ? this.props.datasetId : datasetId,
      attributeId: attributeId === null ? this.props.attributeId : attributeId,
      isChanged: false,
      listClassName: listClassName,
      highlightedClass: highlightedClass,
      showCustomCheckbox : this.props.showCustomCheckbox,
      isNodeHasActions : this.props.isNodeHasActions,
      activeItemclass: props.firstDataset ? true : false,
      activeNodeId: null,
      businessAreaId: this.props.businessAreaId || BusinessAreaId,
      kpiId: this.props.kpiId || kpiId,
      subjectAreaId: this.props.subjectAreaId || SubjectAreaId


    };
    this.getIcon = this.getIcon.bind(this);
  }


  componentDidUpdate(prevProps) {
    if (prevProps.highlightedId !== this.props.highlightedId) {
      this.setState({ highlightedType: this.props.highlightedType, highlightedId: this.props.highlightedId });
      if (this.props.highlightedId != null && String(this.props.highlightedId) === String(this.props.id) && this.props.highlightedType === this.props.type) {
        this.setState({ highlightedClass: "search-highlight-selected", listClassName: "active" });
      } else {
        this.setState({ highlightedClass: "", listClassName: "" });
      }

    }
  }
  setActiveNode = (nodeId) => {
    this.setState({ activeNodeId: nodeId });
  };

  toggle = (e) => {
    if (this.props.watchListOpen !== true) {
      // Remove active class from all li elements in left panel tree only
      $(".qd-rt_tree-view li").removeClass("active");

      // Add active class to the clicked one
      $(e.currentTarget).closest("li").addClass("active");
    }
      this.setState({
        isOpen: !this.state.isOpen,
      });

      let isChanged = this.state.isChanged
      if (!isChanged) {
        this.setState({ isChanged: true });
      }
    const isChild = this.state.datasetName?.includes("$");
       (this.props.type === "KPI" || this.props.type === "Model" || this.props.type === "SubjectArea" || this.props.type === "BusinessArea") && this.props.watchListOpen !== true && this.props.getLeftPanelTreeDataResponse(this.state.businessAreaId, this.state.subjectAreaId, this.props.type, this.props.id,this.props.selectedWatchlistId)
       if(this.props.watchListOpen !== true)
       { 
        if(this.props.type !== undefined)
         {
           this.props.changeData(this.state.envName, this.state.KPI_name,this.state.datasourceName,
            this.state.datasetName, this.state.attributeName,
            this.state.envId, this.state.datasourceId,
            this.state.datasetId, this.state.attributeId, this.props.id, this.props.type,this.state.isOpen, null,this.props.title,this.state.businessAreaId,this.state.subjectAreaId,this.state.kpiId, isChild ?  true  : "")
         }
      else
        {
       this.props.changeData(this.state.envName,this.state.KPI_name, this.state.datasourceName,
      this.state.datasetName, this.state.attributeName,
      this.state.envId, this.state.datasourceId,
      this.state.datasetId, this.state.attributeId, this.props.id, this.props.type,false, null,this.props.title, this.state.businessAreaId,this.state.subjectAreaId,this.state.kpiId,isChild ?  true  : "")
       }
      }
  this.setState(
      (prevState) => ({
        activeItemclass: true,
      }),
      () => {
        this.setActiveNode(this.props.id);
      
      }
    )
    };
    getIcon(type) {
      if (type === "Environment") {
        return faServer;
      } else if (type === "Datasource") {
        return faDatabase;
      } else if (type === "Dataset") {
        return faLayerGroup;
      } else {
        return faTag;
      }
    }
  getUlClassName(type, childNodes) {
    let className = "";

    if (!Array.isArray(childNodes)) {
      childNodes = [];
    }

    const isActive = this.state.isOpen || (this.props.isSearchHappened && !this.state.isChanged);

    if (type === "BusinessArea") {
      className = isActive ? "nested tree_top-level active" : "nested";
    } else if (type === "SubjectArea") {
      className = isActive ? "nested active" : "nested";
    } else if (type === "Datasource") {
      className = isActive ? "nested active" : "nested";
    } else if (["Dataset", "KPI","KPIs","Models", "Model", "Metrics", "CustomMetrics","Metric","CustomMetric"].includes(type) && childNodes.length > 0 && this.props.showCustomCheckbox !== true) {
      className = isActive ? "nested active" : "nested";
    } else if (type === "Attribute" && childNodes.length > 0 && this.props.showCustomCheckbox !== true) {
      className = isActive ? "nested active" : "nested ";
    } else {
      className = isActive ? "nested has-no-caret active" : "nested has-no-caret";
    }

    return className;
  }

    getHighlightedText(text, highlight) {
      const safeText = String(text ?? "");
      const safeHighlight = String(highlight ?? "");
      if (!safeHighlight) return safeText;

      const escapedHighlight = safeHighlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const parts = safeText.split(new RegExp(`(${escapedHighlight})`, 'gi'));
      return (parts.map((part, i) =>
        <span key={i} className={part.toLowerCase() === safeHighlight.toLowerCase() ? (this.props.isTreeSearch ? "tree-search-text-highlight" : "search-text-highlight") : ""}>
          {part}
        </span>)
      );
    }
componentDidMount() {

  const {
    firstBusinessArea,
    firstSubjectArea,
    firstKPI,
    firstDataset,
    id,
    type,
    title,firstDatasource
  } = this.props;
  const isSearchMode = Boolean(this.props.isTreeSearch || this.props.subString);

  // FIX: Only first KPI should auto-open
  if (type === "KPI" && !firstKPI) {
    return;
  }

  // Existing logic
  const shouldOpen = firstBusinessArea || firstSubjectArea || firstKPI || firstDataset ||  firstDatasource || (title === "KPIs" && this.props.watchListOpen !== true);

  if (shouldOpen) {

    // Auto-open in UI
    this.setState({ isActive: true, isOpen: true }, async () => {
      // this.setActiveNode(id);

     this.s = `${id}_node`;


const elem = document.getElementById(this.s);
if (elem) {
  $(`#${this.state.datasetId}`).addClass("open");
}


      // Trigger the data loader only if it's not a search render or a dataset/datasource node nested under a KPI.
      const isNonKpiUnderKpi = type !== "KPI" && (this.state.kpiId || this.props.kpiId);
      if (!isSearchMode && !isNonKpiUnderKpi) {
        await this.props.changeData(
          this.state.envName,this.state.KPI_name,
          this.state.datasourceName,
          this.state.datasetName,
          this.state.attributeName,
          this.state.envId,
          this.state.datasourceId,
          this.state.datasetId,
          this.state.attributeId,
          id,
          type,
          false,null,title,
          this.state.businessAreaId,this.state.subjectAreaId,this.state.kpiId
        );
      }
    });
  }
}

    render() {


      const { title, childNodes, type,latest,previous } = this.props;
      const isUnmappedKpi = this.state.isNodeHasActions &&
        childNodes.length === 0 &&
        (type || "").toUpperCase() === "KPI" &&
        !this.props.showCustomCheckbox;


      let ulClassName = this.getUlClassName(type,childNodes);
      let childrenLength = childNodes.filter(x => x.isShow === true)
   let normalizedType = (this.props.type || "").replace(/\s+/g, "");
   let uniqueId = "";

    if (normalizedType === "Datasource") {
      uniqueId = `Datasource-${this.state.datasourceId}`;
    } else if (normalizedType === "Dataset") {
      uniqueId = `Dataset-${this.state.datasetId}`;
    } else if (normalizedType === "Attribute") {
      uniqueId = `Attribute-${this.state.attributeId}`;
    } else if (normalizedType === "BusinessArea") {
      uniqueId = `BusinessArea-${this.state.businessAreaId}`;
    } else if (normalizedType === "SubjectArea") {
      uniqueId = `SubjectArea-${this.state.subjectAreaId}`;
    } else if (normalizedType === "KPI") {
      uniqueId = `KPI-${this.props.id}`;
    } else if (normalizedType === "Metrics") {
      let id = this.state.datasetId || "";
      if (this.state.attributeId !== undefined) {
        id = `${id}-${this.state.attributeId}`;
      }
      uniqueId = `Metrics-${id}`;
    } else if (normalizedType === "PartitionGroup") {
      uniqueId = `PartitionGroup-${this.props.id}`;
    } else if (normalizedType === "Partition") {
      uniqueId = `Partition-${this.props.id}`;
    } else if (normalizedType === "PartitionAttribute") {
      uniqueId = `PartitionAttribute-${this.props.id}`;
    }
      return (
        <li className={`${ this.props.firstKPI || (this.props.firstDataset && !this.state.kpiId) ? "active" : ""}`} id={uniqueId}   onClick={() => this.setActiveNode(this.props.id)}>
          {type !== "Attributee" ? 
        <div className={ childNodes.length === 0 && !["BusinessArea", "Attribute"].includes(type) && !this.props._isStub ? (this.props.showCustomCheckbox !== true ? "d-flex align-items-end w-100" : "caret caret-invisible"):  (this.state.isOpen || (this.props.isSearchHappened && ["BusinessArea","SubjectArea","Dataset"].includes(type) && !(this.state.isChanged) && childNodes.length !== 0) ? "caret caret-down" : "caret")}
      onClick={this.toggle}  id={type+"-left-panel-div-"+uniqueId+type}

    >
            
              <div className="qd_tree-label tw-inline-flex tw-items-center tw-gap-1.5 tw-min-w-0 tw-max-w-max after:!tw-content-none after:!tw-hidden" style={{ pointerEvents: this.props.is_disabled === true ? "none" : "auto", opacity: this.props.is_disabled ? 0.5 : 1 }}        >
                {type === "Dataset" && (
                  <>
                    <RcTooltip
                      placement="top"
                      overlayClassName="rc-tooltip-sm"
                      overlay={
                        <div className="tw-flex tw-items-center tw-p-[2px] tw-gap-[4px] tw-text-[#F0F0F1] tw-text-xs">
                          <FontAwesomeIcon icon={faDatabase} className="tw-mr-[2px] tw-text-[#F1F1F2]" />
                          <span>{this.props.integrationName || 'Datasource'}</span>
                        </div>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                    >
                      <span className='ellipsis-dots'>...</span>
                    </RcTooltip>
                    <i className='!tw-mr-0'>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M6.3 6L4 3.7L4.7 3L7.7 6L4.7 9L4 8.3L6.3 6Z" fill="#D4D4D4" />
                      </svg>
                    </i>
                  </>
                )}
            {this.props.showCustomCheckbox ?
              <input
              type="checkbox"
              id={this.props.id}
              label=""
              className="mr-2"
              onClick={(event) => {
            event.stopPropagation();
            this.props.handleSaveWatchlistCheckboxChange(
              event,
              this.props.type,
              this.props.id, // pass raw id, not full uniqueId here
              this.props.childNodes,this.props.title,this.state.subjectAreaId, this.state.businessAreaId
            );
          }}
checked={
     this.props.checkedStates?.[`${this.props.type}-${this.props.id}`]?.checked 
  }
   
              custom
              /> : ''  
            }
           {type !== "Partition Group" && <i>
            { type === "Metrics" ? 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM5.33333 6.66667C5.14444 6.66667 4.98611 6.73056 4.85833 6.85833C4.73056 6.98611 4.66667 7.14444 4.66667 7.33333V10.6667C4.66667 10.8556 4.73056 11.0139 4.85833 11.1417C4.98611 11.2694 5.14444 11.3333 5.33333 11.3333C5.52222 11.3333 5.68056 11.2694 5.80833 11.1417C5.93611 11.0139 6 10.8556 6 10.6667V7.33333C6 7.14444 5.93611 6.98611 5.80833 6.85833C5.68056 6.73056 5.52222 6.66667 5.33333 6.66667ZM8 4.66667C7.81111 4.66667 7.65278 4.73056 7.525 4.85833C7.39722 4.98611 7.33333 5.14444 7.33333 5.33333V10.6667C7.33333 10.8556 7.39722 11.0139 7.525 11.1417C7.65278 11.2694 7.81111 11.3333 8 11.3333C8.18889 11.3333 8.34722 11.2694 8.475 11.1417C8.60278 11.0139 8.66667 10.8556 8.66667 10.6667V5.33333C8.66667 5.14444 8.60278 4.98611 8.475 4.85833C8.34722 4.73056 8.18889 4.66667 8 4.66667ZM10.6667 8.66667C10.4778 8.66667 10.3194 8.73056 10.1917 8.85833C10.0639 8.98611 10 9.14444 10 9.33333V10.6667C10 10.8556 10.0639 11.0139 10.1917 11.1417C10.3194 11.2694 10.4778 11.3333 10.6667 11.3333C10.8556 11.3333 11.0139 11.2694 11.1417 11.1417C11.2694 11.0139 11.3333 10.8556 11.3333 10.6667V9.33333C11.3333 9.14444 11.2694 8.98611 11.1417 8.85833C11.0139 8.73056 10.8556 8.66667 10.6667 8.66667Z" fill="currentColor"/>
            </svg> : (type === "CustomMetrics" ? <Image src="icon_insert_setting_chart"/>
              : type === "BusinessArea" ?  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.85">
            <path d="M9.43484 6.46745C9.26351 6.46745 9.1204 6.40995 9.00551 6.29495C8.89051 6.18006 8.83301 6.03567 8.83301 5.86178V3.40661C8.83301 3.23261 8.89095 3.08817 9.00684 2.97328C9.12273 2.85828 9.26629 2.80078 9.43751 2.80078H13.0645C13.2358 2.80078 13.379 2.85828 13.4938 2.97328C13.6088 3.08817 13.6663 3.23261 13.6663 3.40661V5.86178C13.6663 6.03567 13.6084 6.18006 13.4925 6.29495C13.3766 6.40995 13.2331 6.46745 13.0618 6.46745H9.43484ZM2.93484 8.80078C2.76351 8.80078 2.6204 8.74328 2.50551 8.62828C2.39051 8.51328 2.33301 8.37078 2.33301 8.20078V3.40061C2.33301 3.23061 2.39095 3.08817 2.50684 2.97328C2.62273 2.85828 2.76629 2.80078 2.93751 2.80078H6.56451C6.73584 2.80078 6.87895 2.85828 6.99384 2.97328C7.10884 3.08828 7.16634 3.23078 7.16634 3.40078V8.20095C7.16634 8.37095 7.1084 8.51339 6.99251 8.62828C6.87662 8.74328 6.73306 8.80078 6.56184 8.80078H2.93484ZM9.43484 14.1341C9.26351 14.1341 9.1204 14.0766 9.00551 13.9616C8.89051 13.8466 8.83301 13.7041 8.83301 13.5341V8.73395C8.83301 8.56395 8.89095 8.4215 9.00684 8.30661C9.12273 8.19161 9.26629 8.13411 9.43751 8.13411H13.0645C13.2358 8.13411 13.379 8.19161 13.4938 8.30661C13.6088 8.42161 13.6663 8.56411 13.6663 8.73411V13.5343C13.6663 13.7043 13.6084 13.8467 13.4925 13.9616C13.3766 14.0766 13.2331 14.1341 13.0618 14.1341H9.43484ZM2.93484 14.1341C2.76351 14.1341 2.6204 14.0766 2.50551 13.9616C2.39051 13.8467 2.33301 13.7023 2.33301 13.5283V11.0731C2.33301 10.8992 2.39095 10.7548 2.50684 10.6399C2.62273 10.5249 2.76629 10.4674 2.93751 10.4674H6.56451C6.73584 10.4674 6.87895 10.5249 6.99384 10.6399C7.10884 10.7548 7.16634 10.8992 7.16634 11.0731V13.5283C7.16634 13.7023 7.1084 13.8467 6.99251 13.9616C6.87662 14.0766 6.73306 14.1341 6.56184 14.1341H2.93484Z" fill="#4B5675"/>
            </g>
            </svg>
            : type === "SubjectArea" ? <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.077 13.138C2.77011 13.138 2.51389 13.0352 2.30833 12.8297C2.10278 12.6241 2 12.3679 2 12.061V4.88169C2 4.5748 2.10278 4.31858 2.30833 4.11302C2.51389 3.90747 2.77011 3.80469 3.077 3.80469H5.95C6.09356 3.80469 6.23311 3.83374 6.36867 3.89185C6.50411 3.94996 6.62011 4.0273 6.71667 4.12385L7.73083 5.13802H12.923C13.2299 5.13802 13.4861 5.2408 13.6917 5.44635C13.8972 5.65191 14 5.90813 14 6.21502V12.061C14 12.3679 13.8972 12.6241 13.6917 12.8297C13.4861 13.0352 13.2299 13.138 12.923 13.138H3.077Z" fill="#4B5675"/>
            </svg>
            : type === "Models"? <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99967 2.16797C8.21155 2.16797 8.41232 2.22271 8.60189 2.33203L13.0635 4.90039C13.2533 5.00972 13.4015 5.15565 13.5075 5.33854C13.6135 5.52154 13.6663 5.72263 13.6663 5.94141V9.58333C13.549 9.51581 13.427 9.45356 13.2992 9.39844C12.8935 9.22347 12.4601 9.13607 11.999 9.13607C11.5381 9.13607 11.105 9.22348 10.6995 9.39844C10.294 9.57352 9.94089 9.81127 9.64095 10.1113C9.34106 10.4114 9.10366 10.7643 8.92871 11.1699C8.75375 11.5756 8.66634 12.009 8.66634 12.4701C8.66635 12.9309 8.75376 13.3641 8.92871 13.7695C9.00453 13.9451 9.09313 14.1105 9.19238 14.2663L8.60189 14.6068C8.4123 14.7161 8.21157 14.7708 7.99967 14.7708C7.78778 14.7708 7.58705 14.7161 7.39746 14.6068L2.93587 12.0384C2.74609 11.9291 2.59786 11.7831 2.49186 11.6003C2.3859 11.4173 2.33301 11.2161 2.33301 10.9974V5.94141C2.33301 5.72263 2.38586 5.52154 2.49186 5.33854C2.59786 5.15565 2.7461 5.00972 2.93587 4.90039L7.39746 2.33203C7.58703 2.22271 7.7878 2.16797 7.99967 2.16797ZM7.99967 7.89518L3.88314 5.51562L3.39746 5.79753C3.37606 5.81039 3.35995 5.82768 3.34928 5.84896C3.33862 5.87029 3.33301 5.89197 3.33301 5.91341V6.34375L7.49967 8.75651V13.5156L7.90983 13.7513C7.93983 13.7684 7.96979 13.7773 7.99967 13.7773C8.02956 13.7773 8.05952 13.7684 8.08952 13.7513L8.49967 13.5156V8.75651L12.6663 6.34375V5.91341C12.6663 5.89197 12.6607 5.87029 12.6501 5.84896C12.6394 5.82768 12.6233 5.81039 12.6019 5.79753L12.1162 5.51562L7.99967 7.89518Z" fill="#4B5675"/>
            <path d="M12.0335 13.8027V10.4694H12.6326V13.8027H12.0335ZM10.6663 13.8027V11.4734H11.2654V13.8027H10.6663ZM13.4006 13.8027V11.9778H13.9997V13.8027H13.4006Z" fill="#4B5675"/>
            </svg> : type === "KPIs" ? <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7695 3.84375C15.1483 3.84383 15.469 3.97488 15.7314 4.2373C15.9939 4.49973 16.1249 4.82049 16.125 5.19922V13.7383C16.1249 14.117 15.9939 14.4378 15.7314 14.7002C15.469 14.9626 15.1483 15.0937 14.7695 15.0938H3.23047C2.85174 15.0937 2.53098 14.9626 2.26855 14.7002C2.00613 14.4378 1.87508 14.117 1.875 13.7383V5.19922C1.87508 4.82049 2.00613 4.49973 2.26855 4.2373C2.53098 3.97488 2.85174 3.84383 3.23047 3.84375H14.7695ZM13.6396 8.00879C12.7916 8.00879 12.3205 8.46186 12.3203 9.01367C12.3203 10.2047 14.0869 9.82769 14.0869 10.3506C14.0867 10.4957 13.9527 10.6113 13.6973 10.6113C13.4243 10.6113 13.2206 10.4608 13.1973 10.2344H12.2158C12.2625 10.8617 12.8435 11.3438 13.709 11.3438C14.5221 11.3437 15.0213 10.9198 15.0215 10.3564C15.0041 9.14798 13.25 9.51318 13.25 8.99609C13.2502 8.8395 13.3782 8.74707 13.6104 8.74707C13.8889 8.74714 14.0577 8.8918 14.0869 9.1123H15.0049C14.9408 8.47353 14.4758 8.00896 13.6396 8.00879ZM3 7.21875V11.2969H3.99316V9.49609L5.36426 11.2969H6.5791L4.94043 9.21777L6.52051 7.21875H5.35254L3.99316 9.00781V7.21875H3ZM7.05078 11.2969H8.04395V9.83301H8.66016C9.69991 9.83301 10.159 9.20601 10.1592 8.53223C10.1592 7.78275 9.65946 7.21875 8.66016 7.21875H7.05078V11.2969ZM10.6768 11.2969H11.6699V7.21875H10.6768V11.2969ZM8.58496 8.02051C8.97987 8.02058 9.14844 8.21855 9.14844 8.53223C9.14828 8.84565 8.97969 9.04289 8.58496 9.04297H8.04395V8.02051H8.58496Z" fill="#4B5675"/>
            </svg>
             :type === "Model" ? <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.39717 14.6065L2.93567 12.0385C2.7459 11.9291 2.59801 11.783 2.49201 11.6001C2.38601 11.4171 2.33301 11.2162 2.33301 10.9975V5.94114C2.33301 5.72236 2.38601 5.52147 2.49201 5.33847C2.59801 5.15558 2.7459 5.00947 2.93567 4.90014L7.39717 2.33214C7.58684 2.22269 7.78767 2.16797 7.99967 2.16797C8.21167 2.16797 8.41251 2.22269 8.60217 2.33214L13.0637 4.90014C13.2535 5.00947 13.4013 5.15558 13.5073 5.33847C13.6133 5.52147 13.6663 5.72236 13.6663 5.94114V10.9975C13.6663 11.2162 13.6133 11.4171 13.5073 11.6001C13.4013 11.783 13.2535 11.9291 13.0637 12.0385L8.60217 14.6065C8.41251 14.7159 8.21167 14.7706 7.99967 14.7706C7.78767 14.7706 7.58684 14.7159 7.39717 14.6065ZM7.49967 8.75647V13.5155L7.90984 13.7513C7.93984 13.7684 7.96979 13.777 7.99967 13.777C8.02956 13.777 8.05951 13.7684 8.08951 13.7513L8.49967 13.5155V8.75647L12.6663 6.34364V5.91297C12.6663 5.89152 12.661 5.87014 12.6503 5.8488C12.6397 5.82747 12.6236 5.81036 12.6022 5.79747L12.1163 5.51547L7.99967 7.89497L3.88301 5.51547L3.39717 5.79747C3.37573 5.81036 3.35967 5.82747 3.34901 5.8488C3.33834 5.87014 3.33301 5.89152 3.33301 5.91297V6.34364L7.49967 8.75647Z" fill="#4B5675"/>
            </svg>
            : type === "KPI" ? <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7695 3.84375C15.1483 3.84383 15.469 3.97488 15.7314 4.2373C15.9939 4.49973 16.1249 4.82049 16.125 5.19922V13.7383C16.1249 14.117 15.9939 14.4378 15.7314 14.7002C15.469 14.9626 15.1483 15.0937 14.7695 15.0938H3.23047C2.85174 15.0937 2.53098 14.9626 2.26855 14.7002C2.00613 14.4378 1.87508 14.117 1.875 13.7383V5.19922C1.87508 4.82049 2.00613 4.49973 2.26855 4.2373C2.53098 3.97488 2.85174 3.84383 3.23047 3.84375H14.7695ZM4.5 7.21875V11.2969H5.49316V9.49609L6.86426 11.2969H8.0791L6.44043 9.21777L8.02051 7.21875H6.85254L5.49316 9.00781V7.21875H4.5ZM8.55078 11.2969H9.54395V9.83301H10.1602C11.1999 9.83301 11.659 9.20601 11.6592 8.53223C11.6592 7.78275 11.1595 7.21875 10.1602 7.21875H8.55078V11.2969ZM12.1768 11.2969H13.1699V7.21875H12.1768V11.2969ZM10.085 8.02051C10.4799 8.02058 10.6484 8.21855 10.6484 8.53223C10.6483 8.84565 10.4797 9.04289 10.085 9.04297H9.54395V8.02051H10.085Z" fill="#B5B5C3"/>
            </svg>
            : type === "Dataset" ? (
                <FontAwesomeIcon icon={faLayerGroup} />
              )
              : type === "Attribute" ?  <FontAwesomeIcon icon={faTag} /> : type === "Datasource" ? (
                <FontAwesomeIcon icon={faDatabase} />
              ):(
                getIconforMetrics(title)
              ))}
              {this.props.error && <sup>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.26392C5.14167 7.26392 5.26042 7.21751 5.35625 7.1247C5.45208 7.03188 5.5 6.91687 5.5 6.77966C5.5 6.64245 5.45208 6.52744 5.35625 6.43462C5.26042 6.34181 5.14167 6.2954 5 6.2954C4.85833 6.2954 4.73958 6.34181 4.64375 6.43462C4.54792 6.52744 4.5 6.64245 4.5 6.77966C4.5 6.91687 4.54792 7.03188 4.64375 7.1247C4.73958 7.21751 4.85833 7.26392 5 7.26392ZM5 5.32688C5.14167 5.32688 5.26042 5.28047 5.35625 5.18765C5.45208 5.09483 5.5 4.97982 5.5 4.84262V2.90557C5.5 2.76836 5.45208 2.65335 5.35625 2.56053C5.26042 2.46772 5.14167 2.42131 5 2.42131C4.85833 2.42131 4.73958 2.46772 4.64375 2.56053C4.54792 2.65335 4.5 2.76836 4.5 2.90557V4.84262C4.5 4.97982 4.54792 5.09483 4.64375 5.18765C4.73958 5.28047 4.85833 5.32688 5 5.32688ZM5 9.68523C4.30833 9.68523 3.65833 9.55811 3.05 9.30387C2.44167 9.04964 1.9125 8.7046 1.4625 8.26877C1.0125 7.83293 0.65625 7.32042 0.39375 6.73124C0.13125 6.14205 0 5.51251 0 4.84262C0 4.17272 0.13125 3.54318 0.39375 2.95399C0.65625 2.36481 1.0125 1.8523 1.4625 1.41646C1.9125 0.98063 2.44167 0.635593 3.05 0.381356C3.65833 0.127119 4.30833 0 5 0C5.69167 0 6.34167 0.127119 6.95 0.381356C7.55833 0.635593 8.0875 0.98063 8.5375 1.41646C8.9875 1.8523 9.34375 2.36481 9.60625 2.95399C9.86875 3.54318 10 4.17272 10 4.84262C10 5.51251 9.86875 6.14205 9.60625 6.73124C9.34375 7.32042 8.9875 7.83293 8.5375 8.26877C8.0875 8.7046 7.55833 9.04964 6.95 9.30387C6.34167 9.55811 5.69167 9.68523 5 9.68523Z" fill="#F64E60"/>
                </svg>
              </sup>}
            </i>}
              {type === "Metric" ? (
              <RcTooltip
                placement="top"
                overlayClassName="rc-tooltip-sm"
                overlay={<span style={{ wordBreak: "break-word" }}>{title}</span>}
                trigger={["hover"]}
                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
              >
                <span className="tw-truncate tw-min-w-0">
                  {this.props.subString
                    ? this.getHighlightedText(
                        title,
                        this.props.subString || this.props.saveWatchListSearchText
                      )
                    : title}
                </span>
              </RcTooltip>
            ) : (
              <span className="tw-truncate tw-min-w-0">
                {wrapNameWithTooltip(
                  title,
                  22,
                  this.props.subString
                    ? this.getHighlightedText(
                        title,
                        this.props.subString || this.props.saveWatchListSearchText
                      )
                    : null
                )}
              </span>
            )}
              </div>
            {isUnmappedKpi && (
              <span className="qd-badge-unmapped tw-inline-flex tw-items-center tw-px-1.5 tw-py-[1px] tw-text-[10px] tw-font-medium tw-text-[#535862] dark:tw-text-[#B2B5BE] tw-bg-[#F4F4F5] dark:tw-bg-[#27272A] tw-border tw-border-solid tw-border-[#E4E4E7] dark:tw-border-[#3F3F46] tw-rounded tw-shrink-0 tw-whitespace-nowrap tw-ml-1.5">
                Unmapped
              </span>
            )}
            { this.state.isNodeHasActions && childNodes.length === 0  && type !== "Dataset" && type !== "Datasource" && !this.props.showCustomCheckbox?

           <div className={isUnmappedKpi ? "before:!tw-content-none before:!tw-hidden" : "qd_tree-actions before:!tw-content-none before:!tw-hidden"}>
             {!(Number(latest) === 0 && Number(previous) === 0) && (
             <span className="performance-stats">
              {this.props.arrowIndicator === true && latest !== previous && <span className="svg-icon">
                {previous === "NA" || latest > previous ? (
                 <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M6.93056 2.2207C7.01867 2.2207 7.1037 2.23629 7.18565 2.26746C7.26759 2.29863 7.3416 2.34726 7.40769 2.41335L10.3074 5.31302C10.4358 5.44145 10.5 5.60049 10.5 5.79014C10.5 5.9798 10.4358 6.13884 10.3074 6.26727C10.1752 6.40429 10.0152 6.47186 9.82743 6.46999C9.63964 6.46812 9.48154 6.40055 9.35312 6.26727L7.61321 4.53297L7.61321 12.0381C7.61321 12.2277 7.54685 12.3889 7.41413 12.5216C7.2814 12.6543 7.12021 12.7207 6.93056 12.7207C6.74091 12.7207 6.57972 12.6543 6.44699 12.5216C6.31427 12.3889 6.24791 12.2277 6.24791 12.0381L6.24791 4.53297L4.51361 6.26727C4.37659 6.40429 4.2154 6.47279 4.03004 6.47279C3.84468 6.47279 3.68349 6.40429 3.54648 6.26727C3.41319 6.13025 3.34777 5.96906 3.3502 5.7837C3.35263 5.59834 3.41805 5.44145 3.54648 5.31302L6.44616 2.41335C6.51224 2.34727 6.58747 2.29864 6.67184 2.26746C6.75621 2.23629 6.84245 2.2207 6.93056 2.2207Z" fill="#198754"/>
                 </svg>
                 ) :
                 <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M6.93056 12.7188C7.01867 12.7188 7.1037 12.7032 7.18565 12.672C7.26759 12.6408 7.3416 12.5922 7.40769 12.5261L10.3074 9.62644C10.4358 9.49801 10.5 9.33896 10.5 9.14931C10.5 8.95966 10.4358 8.80061 10.3074 8.67218C10.1752 8.53517 10.0152 8.46759 9.82743 8.46947C9.63964 8.47133 9.48154 8.5389 9.35312 8.67218L7.61321 10.4065L7.61321 2.9014C7.61321 2.71175 7.54685 2.55056 7.41413 2.41784C7.2814 2.28511 7.12021 2.21875 6.93056 2.21875C6.74091 2.21875 6.57972 2.28511 6.44699 2.41784C6.31427 2.55056 6.24791 2.71175 6.24791 2.9014L6.24791 10.4065L4.51361 8.67218C4.37659 8.53517 4.2154 8.46666 4.03004 8.46666C3.84468 8.46666 3.68349 8.53517 3.54648 8.67218C3.41319 8.8092 3.34777 8.97039 3.3502 9.15575C3.35263 9.34111 3.41805 9.49801 3.54648 9.62644L6.44616 12.5261C6.51224 12.5922 6.58747 12.6408 6.67184 12.672C6.75621 12.7032 6.84245 12.7188 6.93056 12.7188Z" fill="#F64E60"/>
                 </svg>}
              </span>
              }
              {this.props.newValue === true && latest !== null && latest !== undefined && <span className="new-stat">{latest}</span>}
              {this.props.oldValue === true && previous !== null && previous !== undefined && <span className="old-stat">{previous}</span>}
            </span>
            )}
          </div> : ''}  
  </div>
        : 
        <>
          <div className="qd_tree-label">
            <span onClick={this.toggle} className={this.state.isShow ? (this.state.highlightedClass !== "" ? this.state.highlightedClass : (this.props.subString ? "" : "search-highlight1")) : ""}>
              {/* <i><FontAwesomeIcon icon={this.getIcon(type)} /></i> */}
              {wrapNameWithTooltip(
                title,
                22,
                this.props.subString
                  ? this.getHighlightedText(
                      title,
                      this.props.subString || this.props.saveWatchListSearchText
                    )
                  : null
              )}
            </span> 
          </div>
          {this.state.isNodeHasActions ?
          <div className="qd_tree-actions before:!tw-content-none before:!tw-hidden">
            <span className="performance-stats">
              <span className="svg-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="12.586" height="16" viewBox="0 0 12.586 16">
                  <g id="Group_4665" data-name="Group 4665" transform="translate(-153.47 -392.939)">
                    <rect id="Rectangle_2729" data-name="Rectangle 2729" width="12.586" height="16" transform="translate(153.47 392.939)" fill="none" />
                    <g id="Group_4665-2" data-name="Group 4665" transform="translate(155.746 395.215)">
                      <g id="Group_4668" data-name="Group 4668" transform="translate(0 0)">
                        <path id="Path_1144" data-name="Path 1144" d="M8.957,10.241H7.25V0H8.957Z" transform="translate(-4.086 1.207)" fill="#26a69a" />
                        <path id="Path_1145" data-name="Path 1145" d="M11.3,10.164l-2.81-2.81-2.81,2.81L4.47,8.957,8.487,4.939,12.5,8.957Z" transform="translate(-4.47 -4.939)" fill="#26a69a" />
                      </g>
                    </g>
                  </g>
                </svg>
              </span> 
              <span className="new-stat">168.0</span> 
              <span className="old-stat">16.0</span>
            </span>
            <Dropdown className="tree-node-dropdown">
              <Dropdown.Toggle variant="" id="dropdown-basic">
                <i><FontAwesomeIcon icon={faEllipsisV} /></i>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div> : ''}
        </>}
        {childNodes.length > 0 && (((childrenLength.length > 0 || !this.props.isRedirect) && this.state.isOpen) || (["BusinessArea","SubjectArea","Dataset"].includes(type) && !(this.state.isChanged) && this.props.isSearchHappened)) && (
          <ul className={ulClassName}>
            {childNodes.map(({ id, title, childNodes, type, isOpen, isShow,firstDataset,firstDatasource,firstKPI,firstKPIs,firstSubjectArea,firstBusinessArea,latest,previous,error, businessAreaId,subjectAreaId,kpiId, integrationName, datasourceName, datasourceId, _isStub }) => (
              isShow || !this.props.isRedirect || (["SubjectArea"].includes(type) && this.props.isSearchHappened && !(this.state.isChanged)) ? <Node key={id}
                title={title}
                id={id}
                integrationName={integrationName}
                changeData={this.props.changeData}
                isSearchHappened={this.props.isSearchHappened}
                isTreeSearch={this.props.isTreeSearch}
                envName={this.state.envName}
                envId={this.state.envId}
                isRedirect={this.props.isRedirect}
                highlightedType={this.state.highlightedType}
                highlightedId={this.state.highlightedId}
                datasourceName={datasourceName || this.state.datasourceName}
                datasetName={this.state.datasetName}
                attributeName={this.state.attributeName}
                datasourceId={datasourceId || this.state.datasourceId}
                datasetId={this.state.datasetId}
                attributeId={this.state.attributeId}
                childNodes={childNodes !== undefined ? Object.values(childNodes) : []}
                type={type} isOpen={isOpen}
                subString={this.props.subString}
                isShow={isShow}
                isNodeHasActions = {this.props.isNodeHasActions}
                showCustomCheckbox={this.state.showCustomCheckbox}
                isChanged={this.state.isChanged} 
                renderchartView={this.props.renderchartView}
                firstDataset = {firstDataset}
                firstDatasource={firstDatasource}
                firstKPI = {firstKPI}
                firstKPIs = {firstKPIs}
                firstBusinessArea={firstBusinessArea}
                firstSubjectArea = {firstSubjectArea}
                handleSaveWatchlistCheckboxChange = {this.props.handleSaveWatchlistCheckboxChange}
                checkedStates = {this.props.checkedStates}
                 arrowIndicator={this.props.arrowIndicator}
                newValue = {this.props.newValue}
                oldValue = {this.props.oldValue}
                latest ={latest}
                previous={previous}
                error = {error}
                KPI_name = {this.state.KPI_name}
                activeNodeId={this.state.activeNodeId}
                setActiveNode={this.setActiveNode}
                checkedboxes = {this.props.checkedboxes}
                getLeftPanelTreeDataResponse = {this.props.getLeftPanelTreeDataResponse}
                businessAreaId={businessAreaId || (this.props.type === "BusinessArea" ? this.props.id : this.props.businessAreaId)}
                subjectAreaId={subjectAreaId || (this.props.type === "SubjectArea" ? this.props.id : this.props.subjectAreaId)}
                kpiId={kpiId || (this.props.type === "KPI" ? this.props.id : this.props.kpiId)}
                watchListOpen = {this.props.watchListOpen}
                selectedWatchlistId = {this.props.selectedWatchlistId}
                _isStub={_isStub}
/> : ""
            ))}
          </ul>
        )}
      </li>
    );
  }
}
